import { Fragment as ln, reactive as nr, computed as Q, watchEffect as rr, toRefs as ir, warn as ri, inject as Je, ref as lt, unref as Ne, provide as fn, shallowRef as je, defineComponent as ft, getCurrentInstance as ii, createVNode as j, mergeProps as Mt, isRef as At, toRef as or, Text as oi, useCssVars as si, useCssModule as ai, openBlock as _e, createElementBlock as Re, normalizeClass as De, renderSlot as nt, createElementVNode as Be, createBlock as dn, createCommentVNode as Ye, toDisplayString as at, h as ui, TransitionGroup as ci, Transition as sr, watch as Jt, onBeforeMount as li, nextTick as fi, onBeforeUnmount as di, withDirectives as _n, resolveDirective as hi, vShow as pi, withCtx as ar, createTextVNode as xn, pushScopeId as mi, popScopeId as gi, normalizeStyle as In } from "vue";
const yi = {
  icon: {
    type: String,
    default: null
  },
  iconSize: {
    type: String,
    default: "50"
  },
  iconColor: {
    type: String,
    default: "inherit"
  },
  title: {
    type: String,
    default: ""
  },
  subtitle: {
    type: String,
    default: ""
  },
  backgroundPosition: {
    type: String,
    default: "right center"
  },
  backgroundPositionLeft: {
    type: Boolean,
    default: !1
  },
  backgroundColor: {
    type: String,
    default: null
  },
  backgroundPositionRight: {
    type: Boolean,
    default: !1
  },
  centered: {
    type: Boolean,
    default: !1
  },
  noBackground: {
    type: Boolean,
    default: !1
  },
  backgroundImage: {
    type: String,
    default: null
  },
  backgroundImageUrl: {
    type: String,
    default: null
  },
  contentClass: {
    type: String,
    default: ""
  },
  theme: {
    type: String,
    default: ""
  }
}, wi = typeof window < "u", ur = wi && "IntersectionObserver" in window;
function Se(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${t}` : void 0;
}
function Bn(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Zt(e, t) {
  return t.every((r) => e.hasOwnProperty(r));
}
function vi(e, t) {
  const r = {}, s = new Set(Object.keys(e));
  for (const o of t)
    s.has(o) && (r[o] = e[o]);
  return r;
}
function Mn(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + r.repeat(Math.max(0, t - e.length));
}
function bi(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const r = [];
  let s = 0;
  for (; s < e.length; )
    r.push(e.substr(s, t)), s += t;
  return r;
}
function ze() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
  const s = {};
  for (const o in e)
    s[o] = e[o];
  for (const o in t) {
    const u = e[o], f = t[o];
    if (Bn(u) && Bn(f)) {
      s[o] = ze(u, f, r);
      continue;
    }
    if (Array.isArray(u) && Array.isArray(f) && r) {
      s[o] = r(u, f);
      continue;
    }
    s[o] = f;
  }
  return s;
}
function cr(e) {
  return e.map((t) => t.type === ln ? cr(t.children) : t).flat();
}
function We() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (We.cache.has(e))
    return We.cache.get(e);
  const t = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return We.cache.set(e, t), t;
}
We.cache = /* @__PURE__ */ new Map();
function lr(e) {
  const t = nr({}), r = Q(e);
  return rr(() => {
    for (const s in r.value)
      t[s] = r.value[s];
  }, {
    flush: "sync"
  }), ir(t);
}
function Li(e, t) {
  return e.includes(t);
}
const Ve = 2.4, kn = 0.2126729, Tn = 0.7151522, On = 0.072175, Ei = 0.55, Si = 0.58, Ci = 0.57, Ai = 0.62, wt = 0.03, Fn = 1.45, _i = 5e-4, xi = 1.25, Ii = 1.25, Dn = 0.078, Rn = 12.82051282051282, vt = 0.06, Pn = 1e-3;
function Nn(e, t) {
  const r = (e.r / 255) ** Ve, s = (e.g / 255) ** Ve, o = (e.b / 255) ** Ve, u = (t.r / 255) ** Ve, f = (t.g / 255) ** Ve, l = (t.b / 255) ** Ve;
  let y = r * kn + s * Tn + o * On, p = u * kn + f * Tn + l * On;
  if (y <= wt && (y += (wt - y) ** Fn), p <= wt && (p += (wt - p) ** Fn), Math.abs(p - y) < _i)
    return 0;
  let g;
  if (p > y) {
    const b = (p ** Ei - y ** Si) * xi;
    g = b < Pn ? 0 : b < Dn ? b - b * Rn * vt : b - vt;
  } else {
    const b = (p ** Ai - y ** Ci) * Ii;
    g = b > -Pn ? 0 : b > -Dn ? b - b * Rn * vt : b + vt;
  }
  return g * 100;
}
function st(e) {
  ri(`Vuetify: ${e}`);
}
function tn(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function Bi(e) {
  return tn(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const Un = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, Mi = {
  rgb: (e, t, r, s) => ({
    r: e,
    g: t,
    b: r,
    a: s
  }),
  rgba: (e, t, r, s) => ({
    r: e,
    g: t,
    b: r,
    a: s
  }),
  hsl: (e, t, r, s) => Hn({
    h: e,
    s: t,
    l: r,
    a: s
  }),
  hsla: (e, t, r, s) => Hn({
    h: e,
    s: t,
    l: r,
    a: s
  }),
  hsv: (e, t, r, s) => ut({
    h: e,
    s: t,
    v: r,
    a: s
  }),
  hsva: (e, t, r, s) => ut({
    h: e,
    s: t,
    v: r,
    a: s
  })
};
function it(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && st(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && Un.test(e)) {
    const {
      groups: t
    } = e.match(Un), {
      fn: r,
      values: s
    } = t, o = s.split(/,\s*/).map((u) => u.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(r) ? parseFloat(u) / 100 : parseFloat(u));
    return Mi[r](...o);
  } else if (typeof e == "string") {
    let t = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(t.length) ? t = t.split("").map((s) => s + s).join("") : [6, 8].includes(t.length) || st(`'${e}' is not a valid hex(a) color`);
    const r = parseInt(t, 16);
    return (isNaN(r) || r < 0 || r > 4294967295) && st(`'${e}' is not a valid hex(a) color`), ki(t);
  } else if (typeof e == "object") {
    if (Zt(e, ["r", "g", "b"]))
      return e;
    if (Zt(e, ["h", "s", "l"]))
      return ut(fr(e));
    if (Zt(e, ["h", "s", "v"]))
      return ut(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function ut(e) {
  const {
    h: t,
    s: r,
    v: s,
    a: o
  } = e, u = (l) => {
    const y = (l + t / 60) % 6;
    return s - s * r * Math.max(Math.min(y, 4 - y, 1), 0);
  }, f = [u(5), u(3), u(1)].map((l) => Math.round(l * 255));
  return {
    r: f[0],
    g: f[1],
    b: f[2],
    a: o
  };
}
function Hn(e) {
  return ut(fr(e));
}
function fr(e) {
  const {
    h: t,
    s: r,
    l: s,
    a: o
  } = e, u = s + r * Math.min(s, 1 - s), f = u === 0 ? 0 : 2 - 2 * s / u;
  return {
    h: t,
    s: f,
    v: u,
    a: o
  };
}
function ki(e) {
  e = Ti(e);
  let [t, r, s, o] = bi(e, 2).map((u) => parseInt(u, 16));
  return o = o === void 0 ? o : o / 255, {
    r: t,
    g: r,
    b: s,
    a: o
  };
}
function Ti(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((t) => t + t).join("")), e.length !== 6 && (e = Mn(Mn(e, 6), 8, "F")), e;
}
function Oi(e) {
  const t = Math.abs(Nn(it(0), it(e)));
  return Math.abs(Nn(it(16777215), it(e))) > Math.min(t, 50) ? "#fff" : "#000";
}
function ge(e, t) {
  return (r) => Object.keys(e).reduce((s, o) => {
    const f = typeof e[o] == "object" && e[o] != null && !Array.isArray(e[o]) ? e[o] : {
      type: e[o]
    };
    return r && o in r ? s[o] = {
      ...f,
      default: r[o]
    } : s[o] = f, t && !s[o].source && (s[o].source = t), s;
  }, {});
}
const kt = ge({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component"), _t = Symbol.for("vuetify:defaults");
function hn() {
  const e = Je(_t);
  if (!e)
    throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function Fi(e, t) {
  const r = hn(), s = lt(e), o = Q(() => {
    if (Ne(t?.disabled))
      return r.value;
    const f = Ne(t?.scoped), l = Ne(t?.reset), y = Ne(t?.root);
    if (s.value == null && !(f || l || y))
      return r.value;
    let p = ze(s.value, {
      prev: r.value
    });
    if (f)
      return p;
    if (l || y) {
      const g = Number(l || 1 / 0);
      for (let b = 0; b <= g && !(!p || !("prev" in p)); b++)
        p = p.prev;
      return p && typeof y == "string" && y in p && (p = ze(ze(p, {
        prev: p
      }), p[y])), p;
    }
    return p.prev ? ze(p.prev, p) : p;
  });
  return fn(_t, o), o;
}
function Di(e, t) {
  return typeof e.props?.[t] < "u" || typeof e.props?.[We(t)] < "u";
}
function Ri() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : hn();
  const s = Ue("useDefaults");
  if (t = t ?? s.type.name ?? s.type.__name, !t)
    throw new Error("[Vuetify] Could not determine component name");
  const o = Q(() => r.value?.[e._as ?? t]), u = new Proxy(e, {
    get(y, p) {
      const g = Reflect.get(y, p);
      return p === "class" || p === "style" ? [o.value?.[p], g].filter((b) => b != null) : typeof p == "string" && !Di(s.vnode, p) ? o.value?.[p] !== void 0 ? o.value?.[p] : r.value?.global?.[p] !== void 0 ? r.value?.global?.[p] : g : g;
    }
  }), f = je();
  rr(() => {
    if (o.value) {
      const y = Object.entries(o.value).filter((p) => {
        let [g] = p;
        return g.startsWith(g[0].toUpperCase());
      });
      f.value = y.length ? Object.fromEntries(y) : void 0;
    } else
      f.value = void 0;
  });
  function l() {
    const y = Pi(_t, s);
    fn(_t, Q(() => f.value ? ze(y?.value ?? {}, f.value) : y?.value));
  }
  return {
    props: u,
    provideSubDefaults: l
  };
}
function Tt(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return st("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = ge(e.props ?? {}, e.name)();
    const t = Object.keys(e.props).filter((r) => r !== "class" && r !== "style");
    e.filterProps = function(s) {
      return vi(s, t);
    }, e.props._as = String, e.setup = function(s, o) {
      const u = hn();
      if (!u.value)
        return e._setup(s, o);
      const {
        props: f,
        provideSubDefaults: l
      } = Ri(s, s._as ?? e.name, u), y = e._setup(f, o);
      return l(), y;
    };
  }
  return e;
}
function qe() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (t) => (e ? Tt : ft)(t);
}
function Ue(e, t) {
  const r = ii();
  if (!r)
    throw new Error(`[Vuetify] ${e} ${t || "must be called from inside a setup function"}`);
  return r;
}
function Ot() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = Ue(e).type;
  return We(t?.aliasName || t?.name);
}
function Pi(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ue("injectSelf");
  const {
    provides: r
  } = t;
  if (r && e in r)
    return r[e];
}
function Ft(e) {
  const t = Ue("useRender");
  t.render = e;
}
const xt = {
  badge: "Badge",
  open: "Open",
  close: "Close",
  dismiss: "Dismiss",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancel"
  },
  dataIterator: {
    noResultsText: "No matching records found",
    loadingText: "Loading items..."
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: "Sorted descending.",
      sortAscending: "Sorted ascending.",
      sortNone: "Not sorted.",
      activateNone: "Activate to remove sorting.",
      activateDescending: "Activate to sort descending.",
      activateAscending: "Activate to sort ascending."
    },
    sortBy: "Sort by"
  },
  dataFooter: {
    itemsPerPageText: "Items per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}"
  },
  dateRangeInput: {
    divider: "to"
  },
  datePicker: {
    itemsSelected: "{0} selected",
    range: {
      title: "Select dates",
      header: "Enter dates"
    },
    title: "Select date",
    header: "Enter date",
    input: {
      placeholder: "Enter date"
    }
  },
  noDataText: "No data available",
  carousel: {
    prev: "Previous visual",
    next: "Next visual",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} more",
    today: "Today"
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0} prepended action",
    appendAction: "{0} appended action",
    otp: "Please enter OTP character {0}"
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files ({1} in total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Select Time"
  },
  pagination: {
    ariaLabel: {
      root: "Pagination Navigation",
      next: "Next page",
      previous: "Previous page",
      page: "Go to page {0}",
      currentPage: "Page {0}, Current page",
      first: "First page",
      last: "Last page"
    }
  },
  stepper: {
    next: "Next",
    prev: "Previous"
  },
  rating: {
    ariaLabel: {
      item: "Rating {0} of {1}"
    }
  },
  loading: "Loading...",
  infiniteScroll: {
    loadMore: "Load more",
    empty: "No more"
  }
}, pn = [String, Function, Object, Array], Ni = Symbol.for("vuetify:icons"), Dt = ge({
  icon: {
    type: pn
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), Vn = qe()({
  name: "VComponentIcon",
  props: Dt(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    return () => {
      const s = e.icon;
      return j(e.tag, null, {
        default: () => [e.icon ? j(s, null, null) : r.default?.()]
      });
    };
  }
}), dr = Tt({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: Dt(),
  setup(e, t) {
    let {
      attrs: r
    } = t;
    return () => j(e.tag, Mt(r, {
      style: null
    }), {
      default: () => [j("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((s) => Array.isArray(s) ? j("path", {
        d: s[0],
        "fill-opacity": s[1]
      }, null) : j("path", {
        d: s
      }, null)) : j("path", {
        d: e.icon
      }, null)])]
    });
  }
});
Tt({
  name: "VLigatureIcon",
  props: Dt(),
  setup(e) {
    return () => j(e.tag, null, {
      default: () => [e.icon]
    });
  }
});
Tt({
  name: "VClassIcon",
  props: Dt(),
  setup(e) {
    return () => j(e.tag, {
      class: e.icon
    }, null);
  }
});
const Ui = (e) => {
  const t = Je(Ni);
  if (!t)
    throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: Q(() => {
      const s = Ne(e);
      if (!s)
        return {
          component: Vn
        };
      let o = s;
      if (typeof o == "string" && (o = o.trim(), o.startsWith("$") && (o = t.aliases?.[o.slice(1)])), o || st(`Could not find aliased icon "${s}"`), Array.isArray(o))
        return {
          component: dr,
          icon: o
        };
      if (typeof o != "string")
        return {
          component: Vn,
          icon: o
        };
      const u = Object.keys(t.sets).find((y) => typeof o == "string" && o.startsWith(`${y}:`)), f = u ? o.slice(u.length + 1) : o;
      return {
        component: t.sets[u ?? t.defaultSet].component,
        icon: f
      };
    })
  };
}, nn = Symbol.for("vuetify:theme"), hr = ge({
  theme: String
}, "theme");
function pr(e) {
  Ue("provideTheme");
  const t = Je(nn, null);
  if (!t)
    throw new Error("Could not find Vuetify theme injection");
  const r = Q(() => e.theme ?? t.name.value), s = Q(() => t.themes.value[r.value]), o = Q(() => t.isDisabled ? void 0 : `v-theme--${r.value}`), u = {
    ...t,
    name: r,
    current: s,
    themeClasses: o
  };
  return fn(nn, u), u;
}
function Hi() {
  Ue("useTheme");
  const e = Je(nn, null);
  if (!e)
    throw new Error("Could not find Vuetify theme injection");
  return e;
}
function mn(e) {
  return lr(() => {
    const t = [], r = {};
    if (e.value.background)
      if (tn(e.value.background)) {
        if (r.backgroundColor = e.value.background, !e.value.text && Bi(e.value.background)) {
          const s = it(e.value.background);
          if (s.a == null || s.a === 1) {
            const o = Oi(s);
            r.color = o, r.caretColor = o;
          }
        }
      } else
        t.push(`bg-${e.value.background}`);
    return e.value.text && (tn(e.value.text) ? (r.color = e.value.text, r.caretColor = e.value.text) : t.push(`text-${e.value.text}`)), {
      colorClasses: t,
      colorStyles: r
    };
  });
}
function Vi(e, t) {
  const r = Q(() => ({
    text: At(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: s,
    colorStyles: o
  } = mn(r);
  return {
    textColorClasses: s,
    textColorStyles: o
  };
}
function $i(e, t) {
  const r = Q(() => ({
    background: At(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: s,
    colorStyles: o
  } = mn(r);
  return {
    backgroundColorClasses: s,
    backgroundColorStyles: o
  };
}
const ji = ["x-small", "small", "default", "large", "x-large"], mr = ge({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function gr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ot();
  return lr(() => {
    let r, s;
    return Li(ji, e.size) ? r = `${t}--size-${e.size}` : e.size && (s = {
      width: Se(e.size),
      height: Se(e.size)
    }), {
      sizeClasses: r,
      sizeStyles: s
    };
  });
}
const yr = ge({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), Yi = ge({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: pn,
  ...kt(),
  ...mr(),
  ...yr({
    tag: "i"
  }),
  ...hr()
}, "VIcon"), wr = qe()({
  name: "VIcon",
  props: Yi(),
  setup(e, t) {
    let {
      attrs: r,
      slots: s
    } = t;
    const o = lt(), {
      themeClasses: u
    } = pr(e), {
      iconData: f
    } = Ui(Q(() => o.value || e.icon)), {
      sizeClasses: l
    } = gr(e), {
      textColorClasses: y,
      textColorStyles: p
    } = Vi(or(e, "color"));
    return Ft(() => {
      const g = s.default?.();
      g && (o.value = cr(g).filter((O) => O.type === oi && O.children && typeof O.children == "string")[0]?.children);
      const b = !!(r.onClick || r.onClickOnce);
      return j(f.value.component, {
        tag: e.tag,
        icon: f.value.icon,
        class: ["v-icon", "notranslate", u.value, l.value, y.value, {
          "v-icon--clickable": b,
          "v-icon--disabled": e.disabled,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class],
        style: [l.value ? void 0 : {
          fontSize: Se(e.size),
          height: Se(e.size),
          width: Se(e.size)
        }, p.value, e.style],
        role: b ? "button" : void 0,
        "aria-hidden": !b,
        tabindex: b ? e.disabled ? -1 : 0 : void 0
      }, {
        default: () => [g]
      });
    }), {};
  }
}), zi = /* @__PURE__ */ ft({
  name: "AdsHeader",
  __name: "AdsHeader",
  props: yi,
  setup(e) {
    si((g) => ({
      "292377b3": y.value,
      "1fd3ed19": u.value,
      "23516aa7": f.value,
      "2765dfae": l.value
    }));
    const t = Hi(), r = ai(), s = e, o = Q(
      () => t.name.value === "dark" || s.theme === "dark"
    ), u = Q(() => s.backgroundColor ? s.backgroundColor : o.value ? t.current.value.colors.primary : t.current.value.colors.secondary), f = Q(() => o.value ? "white" : t.current.value.colors.primary), l = Q(() => s.iconColor), y = Q(() => s.backgroundPosition), p = Q(() => {
      const g = [r.banner];
      return s.noBackground ? g.push(r.noBackground) : s.backgroundImage || (o.value ? g.push(r.bgDark) : g.push(r.bgLight)), g;
    });
    return (g, b) => (_e(), Re("div", {
      "data-ads-banner": "",
      class: De(p.value)
    }, [
      nt(g.$slots, "content", {}, () => [
        Be("div", {
          class: De(g.$style.wrapper)
        }, [
          Be("div", {
            class: De(g.$style.leftPanel)
          }, [
            Be("div", {
              class: De(g.$style.content)
            }, [
              nt(g.$slots, "title", {}, () => [
                Be("div", {
                  class: De(g.$style.title)
                }, [
                  nt(g.$slots, "icon", {}, () => [
                    s.icon ? (_e(), dn(wr, {
                      key: 0,
                      alt: "",
                      size: s.iconSize,
                      icon: s.icon
                    }, null, 8, ["size", "icon"])) : Ye("", !0)
                  ]),
                  Be("h1", {
                    class: De(g.$style.heading)
                  }, at(s.title), 3)
                ], 2)
              ]),
              nt(g.$slots, "subtitle", {}, () => [
                g.subtitle ? (_e(), Re("p", {
                  key: 0,
                  class: De(g.$style.subtitle)
                }, at(s.subtitle), 3)) : Ye("", !0)
              ])
            ], 2)
          ], 2),
          Be("div", null, [
            nt(g.$slots, "rightPanel")
          ])
        ], 2)
      ])
    ], 2));
  }
}), Wi = "_banner_hwo46_1", Ji = "_bgLight_hwo46_10", Zi = "_bgDark_hwo46_14", Gi = "_noBackground_hwo46_18", qi = "_wrapper_hwo46_22", Xi = "_content_hwo46_29", Ki = "_leftPanel_hwo46_35", Qi = "_heading_hwo46_40", eo = "_subtitle_hwo46_45", to = "_title_hwo46_50", no = "_icon_hwo46_56", ro = {
  banner: Wi,
  bgLight: Ji,
  bgDark: Zi,
  noBackground: Gi,
  wrapper: qi,
  content: Xi,
  leftPanel: Ki,
  heading: Qi,
  subtitle: eo,
  title: to,
  icon: no
}, Rt = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [s, o] of t)
    r[s] = o;
  return r;
}, io = {
  $style: ro
}, oo = /* @__PURE__ */ Rt(zi, [["__cssModules", io]]), so = {
  givenName: {
    type: String,
    default: ""
  },
  surname: {
    type: String,
    default: ""
  },
  size: {
    type: [String, Number],
    default: "40px"
  }
};
const ao = ge({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), uo = qe(!1)({
  name: "VDefaultsProvider",
  props: ao(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      defaults: s,
      disabled: o,
      reset: u,
      root: f,
      scoped: l
    } = ir(e);
    return Fi(s, {
      reset: u,
      root: f,
      scoped: l,
      disabled: o
    }), () => r.default?.();
  }
});
const co = ge({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function lo(e) {
  return {
    dimensionStyles: Q(() => {
      const r = {}, s = Se(e.height), o = Se(e.maxHeight), u = Se(e.maxWidth), f = Se(e.minHeight), l = Se(e.minWidth), y = Se(e.width);
      return s != null && (r.height = s), o != null && (r.maxHeight = o), u != null && (r.maxWidth = u), f != null && (r.minHeight = f), l != null && (r.minWidth = l), y != null && (r.width = y), r;
    })
  };
}
function fo(e) {
  return {
    aspectStyles: Q(() => {
      const t = Number(e.aspectRatio);
      return t ? {
        paddingBottom: String(1 / t * 100) + "%"
      } : void 0;
    })
  };
}
const vr = ge({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...kt(),
  ...co()
}, "VResponsive"), $n = qe()({
  name: "VResponsive",
  props: vr(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      aspectStyles: s
    } = fo(e), {
      dimensionStyles: o
    } = lo(e);
    return Ft(() => j("div", {
      class: ["v-responsive", {
        "v-responsive--inline": e.inline
      }, e.class],
      style: [o.value, e.style]
    }, [j("div", {
      class: "v-responsive__sizer",
      style: s.value
    }, null), r.additional?.(), r.default && j("div", {
      class: ["v-responsive__content", e.contentClass]
    }, [r.default()])])), {};
  }
}), br = ge({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function Lr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ot();
  return {
    roundedClasses: Q(() => {
      const s = At(e) ? e.value : e.rounded, o = At(e) ? e.value : e.tile, u = [];
      if (s === !0 || s === "")
        u.push(`${t}--rounded`);
      else if (typeof s == "string" || s === 0)
        for (const f of String(s).split(" "))
          u.push(`rounded-${f}`);
      else
        (o || s === !1) && u.push("rounded-0");
      return u;
    })
  };
}
const ho = ge({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), bt = (e, t) => {
  let {
    slots: r
  } = t;
  const {
    transition: s,
    disabled: o,
    group: u,
    ...f
  } = e, {
    component: l = u ? ci : sr,
    ...y
  } = typeof s == "object" ? s : {};
  return ui(l, Mt(typeof s == "string" ? {
    name: o ? "" : s
  } : y, typeof s == "string" ? {} : Object.fromEntries(Object.entries({
    disabled: o,
    group: u
  }).filter((p) => {
    let [g, b] = p;
    return b !== void 0;
  })), f), r);
};
function po(e, t) {
  if (!ur)
    return;
  const r = t.modifiers || {}, s = t.value, {
    handler: o,
    options: u
  } = typeof s == "object" ? s : {
    handler: s,
    options: {}
  }, f = new IntersectionObserver(function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], y = arguments.length > 1 ? arguments[1] : void 0;
    const p = e._observe?.[t.instance.$.uid];
    if (!p)
      return;
    const g = l.some((b) => b.isIntersecting);
    o && (!r.quiet || p.init) && (!r.once || g || p.init) && o(g, l, y), g && r.once ? Er(e, t) : p.init = !0;
  }, u);
  e._observe = Object(e._observe), e._observe[t.instance.$.uid] = {
    init: !1,
    observer: f
  }, f.observe(e);
}
function Er(e, t) {
  const r = e._observe?.[t.instance.$.uid];
  r && (r.observer.unobserve(e), delete e._observe[t.instance.$.uid]);
}
const mo = {
  mounted: po,
  unmounted: Er
}, go = mo, yo = ge({
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...vr(),
  ...kt(),
  ...br(),
  ...ho()
}, "VImg"), wo = qe()({
  name: "VImg",
  directives: {
    intersect: go
  },
  props: yo(),
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, t) {
    let {
      emit: r,
      slots: s
    } = t;
    const {
      backgroundColorClasses: o,
      backgroundColorStyles: u
    } = $i(or(e, "color")), {
      roundedClasses: f
    } = Lr(e), l = Ue("VImg"), y = je(""), p = lt(), g = je(e.eager ? "loading" : "idle"), b = je(), O = je(), M = Q(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), I = Q(() => M.value.aspect || b.value / O.value || 0);
    Jt(() => e.src, () => {
      S(g.value !== "idle");
    }), Jt(I, (H, W) => {
      !H && W && p.value && Y(p.value);
    }), li(() => S());
    function S(H) {
      if (!(e.eager && H) && !(ur && !H && !e.eager)) {
        if (g.value = "loading", M.value.lazySrc) {
          const W = new Image();
          W.src = M.value.lazySrc, Y(W, null);
        }
        M.value.src && fi(() => {
          r("loadstart", p.value?.currentSrc || M.value.src), setTimeout(() => {
            if (!l.isUnmounted)
              if (p.value?.complete) {
                if (p.value.naturalWidth || N(), g.value === "error")
                  return;
                I.value || Y(p.value, null), g.value === "loading" && P();
              } else
                I.value || Y(p.value), $();
          });
        });
      }
    }
    function P() {
      l.isUnmounted || ($(), Y(p.value), g.value = "loaded", r("load", p.value?.currentSrc || M.value.src));
    }
    function N() {
      l.isUnmounted || (g.value = "error", r("error", p.value?.currentSrc || M.value.src));
    }
    function $() {
      const H = p.value;
      H && (y.value = H.currentSrc || H.src);
    }
    let G = -1;
    di(() => {
      clearTimeout(G);
    });
    function Y(H) {
      let W = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const T = () => {
        if (clearTimeout(G), l.isUnmounted)
          return;
        const {
          naturalHeight: _,
          naturalWidth: C
        } = H;
        _ || C ? (b.value = C, O.value = _) : !H.complete && g.value === "loading" && W != null ? G = window.setTimeout(T, W) : (H.currentSrc.endsWith(".svg") || H.currentSrc.startsWith("data:image/svg+xml")) && (b.value = 1, O.value = 1);
      };
      T();
    }
    const te = Q(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), ie = () => {
      if (!M.value.src || g.value === "idle")
        return null;
      const H = j("img", {
        class: ["v-img__img", te.value],
        style: {
          objectPosition: e.position
        },
        src: M.value.src,
        srcset: M.value.srcset,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable,
        sizes: e.sizes,
        ref: p,
        onLoad: P,
        onError: N
      }, null), W = s.sources?.();
      return j(bt, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [_n(W ? j("picture", {
          class: "v-img__picture"
        }, [W, H]) : H, [[pi, g.value === "loaded"]])]
      });
    }, q = () => j(bt, {
      transition: e.transition
    }, {
      default: () => [M.value.lazySrc && g.value !== "loaded" && j("img", {
        class: ["v-img__img", "v-img__img--preload", te.value],
        style: {
          objectPosition: e.position
        },
        src: M.value.lazySrc,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable
      }, null)]
    }), ae = () => s.placeholder ? j(bt, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(g.value === "loading" || g.value === "error" && !s.error) && j("div", {
        class: "v-img__placeholder"
      }, [s.placeholder()])]
    }) : null, de = () => s.error ? j(bt, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [g.value === "error" && j("div", {
        class: "v-img__error"
      }, [s.error()])]
    }) : null, z = () => e.gradient ? j("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, U = je(!1);
    {
      const H = Jt(I, (W) => {
        W && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            U.value = !0;
          });
        }), H());
      });
    }
    return Ft(() => {
      const H = $n.filterProps(e);
      return _n(j($n, Mt({
        class: ["v-img", {
          "v-img--booting": !U.value
        }, o.value, f.value, e.class],
        style: [{
          width: Se(e.width === "auto" ? b.value : e.width)
        }, u.value, e.style]
      }, H, {
        aspectRatio: I.value,
        "aria-label": e.alt,
        role: e.alt ? "img" : void 0
      }), {
        additional: () => j(ln, null, [j(ie, null, null), j(q, null, null), j(z, null, null), j(ae, null, null), j(de, null, null)]),
        default: s.default
      }), [[hi("intersect"), {
        handler: S,
        options: e.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: y,
      image: p,
      state: g,
      naturalWidth: b,
      naturalHeight: O
    };
  }
}), vo = [null, "default", "comfortable", "compact"], bo = ge({
  density: {
    type: String,
    default: "default",
    validator: (e) => vo.includes(e)
  }
}, "density");
function Lo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ot();
  return {
    densityClasses: Q(() => `${t}--density-${e.density}`)
  };
}
const Eo = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function So(e, t) {
  return j(ln, null, [e && j("span", {
    key: "overlay",
    class: `${t}__overlay`
  }, null), j("span", {
    key: "underlay",
    class: `${t}__underlay`
  }, null)]);
}
const Co = ge({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => Eo.includes(e)
  }
}, "variant");
function Ao(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ot();
  const r = Q(() => {
    const {
      variant: u
    } = Ne(e);
    return `${t}--variant-${u}`;
  }), {
    colorClasses: s,
    colorStyles: o
  } = mn(Q(() => {
    const {
      variant: u,
      color: f
    } = Ne(e);
    return {
      [["elevated", "flat"].includes(u) ? "background" : "text"]: f
    };
  }));
  return {
    colorClasses: s,
    colorStyles: o,
    variantClasses: r
  };
}
const _o = ge({
  start: Boolean,
  end: Boolean,
  icon: pn,
  image: String,
  text: String,
  ...kt(),
  ...bo(),
  ...br(),
  ...mr(),
  ...yr(),
  ...hr(),
  ...Co({
    variant: "flat"
  })
}, "VAvatar"), xo = qe()({
  name: "VAvatar",
  props: _o(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      themeClasses: s
    } = pr(e), {
      colorClasses: o,
      colorStyles: u,
      variantClasses: f
    } = Ao(e), {
      densityClasses: l
    } = Lo(e), {
      roundedClasses: y
    } = Lr(e), {
      sizeClasses: p,
      sizeStyles: g
    } = gr(e);
    return Ft(() => j(e.tag, {
      class: ["v-avatar", {
        "v-avatar--start": e.start,
        "v-avatar--end": e.end
      }, s.value, o.value, l.value, y.value, p.value, f.value, e.class],
      style: [u.value, g.value, e.style]
    }, {
      default: () => [r.default ? j(uo, {
        key: "content-defaults",
        defaults: {
          VImg: {
            cover: !0,
            image: e.image
          },
          VIcon: {
            icon: e.icon
          }
        }
      }, {
        default: () => [r.default()]
      }) : e.image ? j(wo, {
        key: "image",
        src: e.image,
        alt: "",
        cover: !0
      }, null) : e.icon ? j(wr, {
        key: "icon",
        icon: e.icon
      }, null) : e.text, So(!1, "v-avatar")]
    })), {};
  }
}), Io = ["aria-label"], Bo = /* @__PURE__ */ ft({
  name: "AdsInitialsIcon",
  __name: "AdsInitialsIcon",
  props: so,
  setup(e) {
    const t = e, r = Q(() => (t.givenName + " " + t.surname).split(" ").map((o) => o.charAt(0).toLocaleUpperCase()).join(""));
    return (s, o) => (_e(), dn(xo, Mt(s.$attrs, { size: s.size }), {
      default: ar(() => [
        Be("span", {
          class: "initials-icon",
          "aria-label": s.givenName + s.surname
        }, at(r.value), 9, Io)
      ]),
      _: 1
    }, 16, ["size"]));
  }
});
const Mo = /* @__PURE__ */ Rt(Bo, [["__scopeId", "data-v-22a94a12"]]), ko = {
  versionNo: {
    type: String,
    default: ""
  },
  isVisible: {
    type: Boolean,
    default: !1
  },
  environment: {
    type: String,
    default: ""
  }
}, Sr = (e) => (mi("data-v-9ebe0875"), e = e(), gi(), e), To = { key: 0 }, Oo = /* @__PURE__ */ Sr(() => /* @__PURE__ */ Be("b", null, "Version:", -1)), Fo = { key: 1 }, Do = { key: 2 }, Ro = /* @__PURE__ */ Sr(() => /* @__PURE__ */ Be("b", null, "Environment:", -1)), Po = /* @__PURE__ */ ft({
  name: "AdsEnvironmentInfo",
  __name: "AdsEnvironmentInfo",
  props: ko,
  setup(e) {
    const t = e;
    return (r, s) => (_e(), dn(sr, null, {
      default: ar(() => [
        r.isVisible ? (_e(), Re("div", {
          key: 0,
          class: "environment-info",
          "aria-hidden": "true",
          onDblclick: s[0] || (s[0] = (o) => r.$emit("hide"))
        }, [
          r.versionNo ? (_e(), Re("span", To, [
            Oo,
            xn(" " + at(t.versionNo), 1)
          ])) : Ye("", !0),
          r.versionNo && r.environment ? (_e(), Re("br", Fo)) : Ye("", !0),
          r.environment ? (_e(), Re("span", Do, [
            Ro,
            xn(" " + at(t.environment), 1)
          ])) : Ye("", !0)
        ], 32)) : Ye("", !0)
      ]),
      _: 1
    }));
  }
});
const No = /* @__PURE__ */ Rt(Po, [["__scopeId", "data-v-9ebe0875"]]), Uo = {
  appName: {
    type: String,
    default: "my-nsw-gov"
  },
  transparent: {
    type: Boolean,
    default: !1
  },
  size: {
    type: String,
    default: "40px"
  }
}, Ho = ["id"], Vo = ["xlink:href"], $o = /* @__PURE__ */ ft({
  name: "AdsAppIcon",
  __name: "AdsAppIcon",
  props: Uo,
  setup(e) {
    const t = e, r = lt(null), s = (u) => {
      if (!t.transparent && window.iconToClass)
        return window.iconToClass[u];
    }, o = () => {
      const u = t.size ? t.size : "40px";
      return { width: u, height: u };
    };
    return (u, f) => (_e(), Re("div", {
      class: "essential",
      style: In({ width: t.size || "40px", height: t.size || "40px" })
    }, [
      (_e(), Re("svg", {
        id: "svg-" + r.value,
        class: De("icon " + s(t.appName)),
        style: In(o()),
        viewBox: "0 0 58 58"
      }, [
        Be("use", {
          "xlink:href": "#" + t.appName
        }, null, 8, Vo)
      ], 14, Ho))
    ], 4));
  }
});
const jo = /* @__PURE__ */ Rt($o, [["__scopeId", "data-v-93916574"]]), Yo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AdsAppIcon: jo,
  AdsEnvironmentInfo: No,
  AdsHeader: oo,
  AdsInitialsIcon: Mo
}, Symbol.toStringTag, { value: "Module" })), X = {
  RED_01: "#630019",
  RED_02: "#D7153A",
  RED_03: "#FFB8C1",
  RED_04: "#FFE6EA",
  BLUE_01: "#002664",
  BLUE_02: "#146CFD",
  BLUE_03: "#8CE0FF",
  BLUE_04: "#CBEDFD",
  GREEN_01: "#004000",
  GREEN_02: "#00AA45",
  GREEN_03: "#A8EDB3",
  GREEN_04: "#DBFADF",
  ORANGE_01: "#941B00",
  ORANGE_02: "#F3631B",
  ORANGE_03: "#FFCE99",
  ORANGE_04: "#FDEDDF",
  TEAL_01: "#0B3F47",
  TEAL_02: "#2E808E",
  TEAL_03: "#8CDBE5",
  TEAL_04: "#D1EEEA",
  BROWN_01: "#523719",
  BROWN_02: "#B68D5D",
  BROWN_03: "#E8D0B5",
  BROWN_04: "#EDE3D7",
  PURPLE_01: "#441170",
  PURPLE_02: "#8055F1",
  PURPLE_03: "#CEBFFF",
  PURPLE_04: "#E6E1FD",
  FUCHSIA_01: "#65004D",
  FUCHSIA_02: "#D912AE",
  FUCHSIA_03: "#F4B5E6",
  FUCHSIA_04: "#FDDEF2",
  YELLOW_01: "#694800",
  YELLOW_02: "#FAAF05",
  YELLOW_03: "#FDE79A",
  YELLOW_04: "#FFF4CF",
  GREY_01: "#22272B",
  GREY_02: "#495054",
  GREY_03: "#CDD3D6",
  GREY_04: "#EBEBEB",
  GREY_05: "#F2F2F2",
  BLACK: "#000000",
  WHITE: "#FFFFFF"
};
var zo = "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z", Wo = "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", Jo = "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z", Zo = "M7 11H9V13H7V11M21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5M5 7H19V5H5V7M19 19V9H5V19H19M15 13V11H17V13H15M11 13V11H13V13H11M7 15H9V17H7V15M15 17V15H17V17H15M11 17V15H13V17H11Z", Go = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z", qo = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z", Xo = "M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z", Ko = "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z", Qo = "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z", es = "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z", Cr = "M16.5,6V17.5A4,4 0 0,1 12.5,21.5A4,4 0 0,1 8.5,17.5V5A2.5,2.5 0 0,1 11,2.5A2.5,2.5 0 0,1 13.5,5V15.5A1,1 0 0,1 12.5,16.5A1,1 0 0,1 11.5,15.5V6H10V15.5A2.5,2.5 0 0,0 12.5,18A2.5,2.5 0 0,0 15,15.5V5A4,4 0 0,0 11,1A4,4 0 0,0 7,5V17.5A5.5,5.5 0 0,0 12.5,23A5.5,5.5 0 0,0 18,17.5V6H16.5Z", ts = "M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z";
const ns = {
  collapse: "svg:M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z",
  complete: "svg:M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  cancel: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  close: "svg:M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  delete: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  // delete (e.g. v-chip close)
  clear: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  success: "svg:M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z",
  info: "svg:M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  warning: "svg:M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
  error: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  prev: "svg:M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z",
  next: "svg:M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
  checkboxOn: "svg:M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  checkboxOff: "svg:M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
  checkboxIndeterminate: "svg:M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  delimiter: "svg:M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  // for carousel
  sortAsc: "svg:M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z",
  sortDesc: "svg:M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z",
  expand: "svg:M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
  menu: "svg:M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
  subgroup: "svg:M7,10L12,15L17,10H7Z",
  dropdown: "svg:M7,10L12,15L17,10H7Z",
  radioOn: "svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z",
  radioOff: "svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  edit: "svg:M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z",
  ratingEmpty: "svg:M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  ratingFull: "svg:M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z",
  ratingHalf: "svg:M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  loading: "svg:M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12",
  first: "svg:M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z",
  last: "svg:M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z",
  unfold: "svg:M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z",
  file: "svg:M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z",
  plus: "svg:M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  minus: "svg:M19,13H5V11H19V13Z",
  calendar: "svg:M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z",
  treeviewCollapse: "svg:M7,10L12,15L17,10H7Z",
  treeviewExpand: "svg:M10,17L15,12L10,7V17Z",
  eyeDropper: "svg:M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z"
}, rs = {
  component: dr
}, jn = {
  // Overrides
  calendar: {
    name: "mdi-calendar-month-outline",
    svg: Zo
  },
  edit: {
    name: "mdi-pencil-outline",
    svg: ts
  },
  error: {
    name: "mdi-alert-circle",
    svg: Wo
  },
  warning: {
    name: "mdi-alert",
    svg: zo
  },
  // Additions
  cogOutline: {
    name: "mdi-cog-outline",
    svg: Xo
  },
  deleteOutline: {
    name: "mdi-close-circle-outline",
    svg: qo
  },
  errorOutline: {
    name: "mdi-alert-circle-outline",
    svg: Jo
  },
  eyeOutline: {
    name: "mdi-eye-outline",
    svg: Ko
  },
  infoOutline: {
    name: "mdi-information-outline",
    svg: Qo
  },
  magnify: {
    name: "mdi-magnify",
    svg: es
  },
  paperclip: {
    name: "mdi-paperclip",
    svg: Cr
  },
  successOutline: {
    name: "mdi-check-circle-outline",
    svg: Go
  }
}, is = Object.keys(jn).map((e) => ({
  [e]: jn[e].svg
})), os = Object.assign({}, ...is), ss = {
  defaultSet: "mdi",
  sets: {
    mdi: rs
  },
  aliases: {
    ...ns,
    ...os
  }
};
var dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Gt = { exports: {} }, Yn;
function Ar() {
  return Yn || (Yn = 1, function(e, t) {
    (function(r, s) {
      e.exports = s();
    })(dt, function() {
      var r = 1e3, s = 6e4, o = 36e5, u = "millisecond", f = "second", l = "minute", y = "hour", p = "day", g = "week", b = "month", O = "quarter", M = "year", I = "date", S = "Invalid Date", P = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, N = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, $ = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(T) {
        var _ = ["th", "st", "nd", "rd"], C = T % 100;
        return "[" + T + (_[(C - 20) % 10] || _[C] || _[0]) + "]";
      } }, G = function(T, _, C) {
        var k = String(T);
        return !k || k.length >= _ ? T : "" + Array(_ + 1 - k.length).join(C) + T;
      }, Y = { s: G, z: function(T) {
        var _ = -T.utcOffset(), C = Math.abs(_), k = Math.floor(C / 60), A = C % 60;
        return (_ <= 0 ? "+" : "-") + G(k, 2, "0") + ":" + G(A, 2, "0");
      }, m: function T(_, C) {
        if (_.date() < C.date())
          return -T(C, _);
        var k = 12 * (C.year() - _.year()) + (C.month() - _.month()), A = _.clone().add(k, b), F = C - A < 0, R = _.clone().add(k + (F ? -1 : 1), b);
        return +(-(k + (C - A) / (F ? A - R : R - A)) || 0);
      }, a: function(T) {
        return T < 0 ? Math.ceil(T) || 0 : Math.floor(T);
      }, p: function(T) {
        return { M: b, y: M, w: g, d: p, D: I, h: y, m: l, s: f, ms: u, Q: O }[T] || String(T || "").toLowerCase().replace(/s$/, "");
      }, u: function(T) {
        return T === void 0;
      } }, te = "en", ie = {};
      ie[te] = $;
      var q = "$isDayjsObject", ae = function(T) {
        return T instanceof H || !(!T || !T[q]);
      }, de = function T(_, C, k) {
        var A;
        if (!_)
          return te;
        if (typeof _ == "string") {
          var F = _.toLowerCase();
          ie[F] && (A = F), C && (ie[F] = C, A = F);
          var R = _.split("-");
          if (!A && R.length > 1)
            return T(R[0]);
        } else {
          var D = _.name;
          ie[D] = _, A = D;
        }
        return !k && A && (te = A), A || !k && te;
      }, z = function(T, _) {
        if (ae(T))
          return T.clone();
        var C = typeof _ == "object" ? _ : {};
        return C.date = T, C.args = arguments, new H(C);
      }, U = Y;
      U.l = de, U.i = ae, U.w = function(T, _) {
        return z(T, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
      };
      var H = function() {
        function T(C) {
          this.$L = de(C.locale, null, !0), this.parse(C), this.$x = this.$x || C.x || {}, this[q] = !0;
        }
        var _ = T.prototype;
        return _.parse = function(C) {
          this.$d = function(k) {
            var A = k.date, F = k.utc;
            if (A === null)
              return /* @__PURE__ */ new Date(NaN);
            if (U.u(A))
              return /* @__PURE__ */ new Date();
            if (A instanceof Date)
              return new Date(A);
            if (typeof A == "string" && !/Z$/i.test(A)) {
              var R = A.match(P);
              if (R) {
                var D = R[2] - 1 || 0, V = (R[7] || "0").substring(0, 3);
                return F ? new Date(Date.UTC(R[1], D, R[3] || 1, R[4] || 0, R[5] || 0, R[6] || 0, V)) : new Date(R[1], D, R[3] || 1, R[4] || 0, R[5] || 0, R[6] || 0, V);
              }
            }
            return new Date(A);
          }(C), this.init();
        }, _.init = function() {
          var C = this.$d;
          this.$y = C.getFullYear(), this.$M = C.getMonth(), this.$D = C.getDate(), this.$W = C.getDay(), this.$H = C.getHours(), this.$m = C.getMinutes(), this.$s = C.getSeconds(), this.$ms = C.getMilliseconds();
        }, _.$utils = function() {
          return U;
        }, _.isValid = function() {
          return this.$d.toString() !== S;
        }, _.isSame = function(C, k) {
          var A = z(C);
          return this.startOf(k) <= A && A <= this.endOf(k);
        }, _.isAfter = function(C, k) {
          return z(C) < this.startOf(k);
        }, _.isBefore = function(C, k) {
          return this.endOf(k) < z(C);
        }, _.$g = function(C, k, A) {
          return U.u(C) ? this[k] : this.set(A, C);
        }, _.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, _.valueOf = function() {
          return this.$d.getTime();
        }, _.startOf = function(C, k) {
          var A = this, F = !!U.u(k) || k, R = U.p(C), D = function(le, re) {
            var he = U.w(A.$u ? Date.UTC(A.$y, re, le) : new Date(A.$y, re, le), A);
            return F ? he : he.endOf(p);
          }, V = function(le, re) {
            return U.w(A.toDate()[le].apply(A.toDate("s"), (F ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(re)), A);
          }, ee = this.$W, ne = this.$M, ue = this.$D, ve = "set" + (this.$u ? "UTC" : "");
          switch (R) {
            case M:
              return F ? D(1, 0) : D(31, 11);
            case b:
              return F ? D(1, ne) : D(0, ne + 1);
            case g:
              var pe = this.$locale().weekStart || 0, ce = (ee < pe ? ee + 7 : ee) - pe;
              return D(F ? ue - ce : ue + (6 - ce), ne);
            case p:
            case I:
              return V(ve + "Hours", 0);
            case y:
              return V(ve + "Minutes", 1);
            case l:
              return V(ve + "Seconds", 2);
            case f:
              return V(ve + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, _.endOf = function(C) {
          return this.startOf(C, !1);
        }, _.$set = function(C, k) {
          var A, F = U.p(C), R = "set" + (this.$u ? "UTC" : ""), D = (A = {}, A[p] = R + "Date", A[I] = R + "Date", A[b] = R + "Month", A[M] = R + "FullYear", A[y] = R + "Hours", A[l] = R + "Minutes", A[f] = R + "Seconds", A[u] = R + "Milliseconds", A)[F], V = F === p ? this.$D + (k - this.$W) : k;
          if (F === b || F === M) {
            var ee = this.clone().set(I, 1);
            ee.$d[D](V), ee.init(), this.$d = ee.set(I, Math.min(this.$D, ee.daysInMonth())).$d;
          } else
            D && this.$d[D](V);
          return this.init(), this;
        }, _.set = function(C, k) {
          return this.clone().$set(C, k);
        }, _.get = function(C) {
          return this[U.p(C)]();
        }, _.add = function(C, k) {
          var A, F = this;
          C = Number(C);
          var R = U.p(k), D = function(ne) {
            var ue = z(F);
            return U.w(ue.date(ue.date() + Math.round(ne * C)), F);
          };
          if (R === b)
            return this.set(b, this.$M + C);
          if (R === M)
            return this.set(M, this.$y + C);
          if (R === p)
            return D(1);
          if (R === g)
            return D(7);
          var V = (A = {}, A[l] = s, A[y] = o, A[f] = r, A)[R] || 1, ee = this.$d.getTime() + C * V;
          return U.w(ee, this);
        }, _.subtract = function(C, k) {
          return this.add(-1 * C, k);
        }, _.format = function(C) {
          var k = this, A = this.$locale();
          if (!this.isValid())
            return A.invalidDate || S;
          var F = C || "YYYY-MM-DDTHH:mm:ssZ", R = U.z(this), D = this.$H, V = this.$m, ee = this.$M, ne = A.weekdays, ue = A.months, ve = A.meridiem, pe = function(re, he, we, me) {
            return re && (re[he] || re(k, F)) || we[he].slice(0, me);
          }, ce = function(re) {
            return U.s(D % 12 || 12, re, "0");
          }, le = ve || function(re, he, we) {
            var me = re < 12 ? "AM" : "PM";
            return we ? me.toLowerCase() : me;
          };
          return F.replace(N, function(re, he) {
            return he || function(we) {
              switch (we) {
                case "YY":
                  return String(k.$y).slice(-2);
                case "YYYY":
                  return U.s(k.$y, 4, "0");
                case "M":
                  return ee + 1;
                case "MM":
                  return U.s(ee + 1, 2, "0");
                case "MMM":
                  return pe(A.monthsShort, ee, ue, 3);
                case "MMMM":
                  return pe(ue, ee);
                case "D":
                  return k.$D;
                case "DD":
                  return U.s(k.$D, 2, "0");
                case "d":
                  return String(k.$W);
                case "dd":
                  return pe(A.weekdaysMin, k.$W, ne, 2);
                case "ddd":
                  return pe(A.weekdaysShort, k.$W, ne, 3);
                case "dddd":
                  return ne[k.$W];
                case "H":
                  return String(D);
                case "HH":
                  return U.s(D, 2, "0");
                case "h":
                  return ce(1);
                case "hh":
                  return ce(2);
                case "a":
                  return le(D, V, !0);
                case "A":
                  return le(D, V, !1);
                case "m":
                  return String(V);
                case "mm":
                  return U.s(V, 2, "0");
                case "s":
                  return String(k.$s);
                case "ss":
                  return U.s(k.$s, 2, "0");
                case "SSS":
                  return U.s(k.$ms, 3, "0");
                case "Z":
                  return R;
              }
              return null;
            }(re) || R.replace(":", "");
          });
        }, _.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, _.diff = function(C, k, A) {
          var F, R = this, D = U.p(k), V = z(C), ee = (V.utcOffset() - this.utcOffset()) * s, ne = this - V, ue = function() {
            return U.m(R, V);
          };
          switch (D) {
            case M:
              F = ue() / 12;
              break;
            case b:
              F = ue();
              break;
            case O:
              F = ue() / 3;
              break;
            case g:
              F = (ne - ee) / 6048e5;
              break;
            case p:
              F = (ne - ee) / 864e5;
              break;
            case y:
              F = ne / o;
              break;
            case l:
              F = ne / s;
              break;
            case f:
              F = ne / r;
              break;
            default:
              F = ne;
          }
          return A ? F : U.a(F);
        }, _.daysInMonth = function() {
          return this.endOf(b).$D;
        }, _.$locale = function() {
          return ie[this.$L];
        }, _.locale = function(C, k) {
          if (!C)
            return this.$L;
          var A = this.clone(), F = de(C, k, !0);
          return F && (A.$L = F), A;
        }, _.clone = function() {
          return U.w(this.$d, this);
        }, _.toDate = function() {
          return new Date(this.valueOf());
        }, _.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, _.toISOString = function() {
          return this.$d.toISOString();
        }, _.toString = function() {
          return this.$d.toUTCString();
        }, T;
      }(), W = H.prototype;
      return z.prototype = W, [["$ms", u], ["$s", f], ["$m", l], ["$H", y], ["$W", p], ["$M", b], ["$y", M], ["$D", I]].forEach(function(T) {
        W[T[1]] = function(_) {
          return this.$g(_, T[0], T[1]);
        };
      }), z.extend = function(T, _) {
        return T.$i || (T(_, H, z), T.$i = !0), z;
      }, z.locale = de, z.isDayjs = ae, z.unix = function(T) {
        return z(1e3 * T);
      }, z.en = ie[te], z.Ls = ie, z.p = {}, z;
    });
  }(Gt)), Gt.exports;
}
var as = Ar();
const Pt = /* @__PURE__ */ Xe(as);
var _r = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s();
  })(dt, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, s = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, o = /\d\d/, u = /\d\d?/, f = /\d*[^-_:/,()\s\d]+/, l = {}, y = function(S) {
      return (S = +S) + (S > 68 ? 1900 : 2e3);
    }, p = function(S) {
      return function(P) {
        this[S] = +P;
      };
    }, g = [/[+-]\d\d:?(\d\d)?|Z/, function(S) {
      (this.zone || (this.zone = {})).offset = function(P) {
        if (!P || P === "Z")
          return 0;
        var N = P.match(/([+-]|\d\d)/g), $ = 60 * N[1] + (+N[2] || 0);
        return $ === 0 ? 0 : N[0] === "+" ? -$ : $;
      }(S);
    }], b = function(S) {
      var P = l[S];
      return P && (P.indexOf ? P : P.s.concat(P.f));
    }, O = function(S, P) {
      var N, $ = l.meridiem;
      if ($) {
        for (var G = 1; G <= 24; G += 1)
          if (S.indexOf($(G, 0, P)) > -1) {
            N = G > 12;
            break;
          }
      } else
        N = S === (P ? "pm" : "PM");
      return N;
    }, M = { A: [f, function(S) {
      this.afternoon = O(S, !1);
    }], a: [f, function(S) {
      this.afternoon = O(S, !0);
    }], S: [/\d/, function(S) {
      this.milliseconds = 100 * +S;
    }], SS: [o, function(S) {
      this.milliseconds = 10 * +S;
    }], SSS: [/\d{3}/, function(S) {
      this.milliseconds = +S;
    }], s: [u, p("seconds")], ss: [u, p("seconds")], m: [u, p("minutes")], mm: [u, p("minutes")], H: [u, p("hours")], h: [u, p("hours")], HH: [u, p("hours")], hh: [u, p("hours")], D: [u, p("day")], DD: [o, p("day")], Do: [f, function(S) {
      var P = l.ordinal, N = S.match(/\d+/);
      if (this.day = N[0], P)
        for (var $ = 1; $ <= 31; $ += 1)
          P($).replace(/\[|\]/g, "") === S && (this.day = $);
    }], M: [u, p("month")], MM: [o, p("month")], MMM: [f, function(S) {
      var P = b("months"), N = (b("monthsShort") || P.map(function($) {
        return $.slice(0, 3);
      })).indexOf(S) + 1;
      if (N < 1)
        throw new Error();
      this.month = N % 12 || N;
    }], MMMM: [f, function(S) {
      var P = b("months").indexOf(S) + 1;
      if (P < 1)
        throw new Error();
      this.month = P % 12 || P;
    }], Y: [/[+-]?\d+/, p("year")], YY: [o, function(S) {
      this.year = y(S);
    }], YYYY: [/\d{4}/, p("year")], Z: g, ZZ: g };
    function I(S) {
      var P, N;
      P = S, N = l && l.formats;
      for (var $ = (S = P.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(de, z, U) {
        var H = U && U.toUpperCase();
        return z || N[U] || r[U] || N[H].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(W, T, _) {
          return T || _.slice(1);
        });
      })).match(s), G = $.length, Y = 0; Y < G; Y += 1) {
        var te = $[Y], ie = M[te], q = ie && ie[0], ae = ie && ie[1];
        $[Y] = ae ? { regex: q, parser: ae } : te.replace(/^\[|\]$/g, "");
      }
      return function(de) {
        for (var z = {}, U = 0, H = 0; U < G; U += 1) {
          var W = $[U];
          if (typeof W == "string")
            H += W.length;
          else {
            var T = W.regex, _ = W.parser, C = de.slice(H), k = T.exec(C)[0];
            _.call(z, k), de = de.replace(k, "");
          }
        }
        return function(A) {
          var F = A.afternoon;
          if (F !== void 0) {
            var R = A.hours;
            F ? R < 12 && (A.hours += 12) : R === 12 && (A.hours = 0), delete A.afternoon;
          }
        }(z), z;
      };
    }
    return function(S, P, N) {
      N.p.customParseFormat = !0, S && S.parseTwoDigitYear && (y = S.parseTwoDigitYear);
      var $ = P.prototype, G = $.parse;
      $.parse = function(Y) {
        var te = Y.date, ie = Y.utc, q = Y.args;
        this.$u = ie;
        var ae = q[1];
        if (typeof ae == "string") {
          var de = q[2] === !0, z = q[3] === !0, U = de || z, H = q[2];
          z && (H = q[2]), l = this.$locale(), !de && H && (l = N.Ls[H]), this.$d = function(C, k, A) {
            try {
              if (["x", "X"].indexOf(k) > -1)
                return new Date((k === "X" ? 1e3 : 1) * C);
              var F = I(k)(C), R = F.year, D = F.month, V = F.day, ee = F.hours, ne = F.minutes, ue = F.seconds, ve = F.milliseconds, pe = F.zone, ce = /* @__PURE__ */ new Date(), le = V || (R || D ? 1 : ce.getDate()), re = R || ce.getFullYear(), he = 0;
              R && !D || (he = D > 0 ? D - 1 : ce.getMonth());
              var we = ee || 0, me = ne || 0, be = ue || 0, Oe = ve || 0;
              return pe ? new Date(Date.UTC(re, he, le, we, me, be, Oe + 60 * pe.offset * 1e3)) : A ? new Date(Date.UTC(re, he, le, we, me, be, Oe)) : new Date(re, he, le, we, me, be, Oe);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(te, ae, ie), this.init(), H && H !== !0 && (this.$L = this.locale(H).$L), U && te != this.format(ae) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
        } else if (ae instanceof Array)
          for (var W = ae.length, T = 1; T <= W; T += 1) {
            q[1] = ae[T - 1];
            var _ = N.apply(this, q);
            if (_.isValid()) {
              this.$d = _.$d, this.$L = _.$L, this.init();
              break;
            }
            T === W && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          G.call(this, Y);
      };
    };
  });
})(_r);
var us = _r.exports;
const cs = /* @__PURE__ */ Xe(us);
var xr = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s();
  })(dt, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(s, o, u) {
      var f = o.prototype, l = f.format;
      u.en.formats = r, f.format = function(y) {
        y === void 0 && (y = "YYYY-MM-DDTHH:mm:ssZ");
        var p = this.$locale().formats, g = function(b, O) {
          return b.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(M, I, S) {
            var P = S && S.toUpperCase();
            return I || O[S] || r[S] || O[P].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(N, $, G) {
              return $ || G.slice(1);
            });
          });
        }(y, p === void 0 ? {} : p);
        return l.call(this, g);
      };
    };
  });
})(xr);
var ls = xr.exports;
const fs = /* @__PURE__ */ Xe(ls);
var Ir = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s();
  })(dt, function() {
    return function(r, s, o) {
      s.prototype.isBetween = function(u, f, l, y) {
        var p = o(u), g = o(f), b = (y = y || "()")[0] === "(", O = y[1] === ")";
        return (b ? this.isAfter(p, l) : !this.isBefore(p, l)) && (O ? this.isBefore(g, l) : !this.isAfter(g, l)) || (b ? this.isBefore(p, l) : !this.isAfter(p, l)) && (O ? this.isAfter(g, l) : !this.isBefore(g, l));
      };
    };
  });
})(Ir);
var ds = Ir.exports;
const hs = /* @__PURE__ */ Xe(ds);
Pt.extend(cs);
Pt.extend(fs);
Pt.extend(hs);
const ps = (e, t) => t ? (...r) => e(...r).locale(t) : e, ms = {
  normalDateWithWeekday: "ddd, MMM D",
  normalDate: "D MMMM",
  shortDate: "MMM D",
  monthAndDate: "MMMM D",
  dayOfMonth: "D",
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  monthAndYear: "MMMM YYYY",
  weekday: "dddd",
  weekdayShort: "ddd",
  minutes: "mm",
  hours12h: "hh",
  hours24h: "HH",
  seconds: "ss",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  fullDate: "ll",
  fullDateWithWeekday: "dddd, LL",
  fullDateTime: "lll",
  fullDateTime12h: "ll hh:mm A",
  fullDateTime24h: "ll HH:mm",
  keyboardDate: "L",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
};
class gs {
  constructor({ locale: t, formats: r, instance: s } = {}) {
    this.lib = "dayjs", this.is12HourCycleInCurrentLocale = () => {
      var o, u, f;
      return /A|a/.test((f = (u = (o = this.rawDayJsInstance.Ls[this.locale || "en"]) === null || o === void 0 ? void 0 : o.formats) === null || u === void 0 ? void 0 : u.LT) !== null && f !== void 0 ? f : "");
    }, this.getCurrentLocaleCode = () => this.locale || "en", this.getFormatHelperText = (o) => {
      var u, f, l = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?)|./g;
      return (f = (u = o.match(l)) === null || u === void 0 ? void 0 : u.map((y) => {
        var p, g, b = y[0];
        return b === "L" && (g = (p = this.rawDayJsInstance.Ls[this.locale || "en"]) === null || p === void 0 ? void 0 : p.formats[y]) !== null && g !== void 0 ? g : y;
      }).join("").replace(/a/gi, "(a|p)m").toLocaleLowerCase()) !== null && f !== void 0 ? f : o;
    }, this.parseISO = (o) => this.dayjs(o), this.toISO = (o) => o.toISOString(), this.parse = (o, u) => o === "" ? null : this.dayjs(o, u, this.locale, !0), this.date = (o) => o === null ? null : this.dayjs(o), this.toJsDate = (o) => o.toDate(), this.isValid = (o) => this.dayjs(o).isValid(), this.isNull = (o) => o === null, this.getDiff = (o, u, f) => (typeof u == "string" && (u = this.dayjs(u)), u.isValid() ? o.diff(u, f) : 0), this.isAfter = (o, u) => o.isAfter(u), this.isBefore = (o, u) => o.isBefore(u), this.isAfterDay = (o, u) => o.isAfter(u, "day"), this.isBeforeDay = (o, u) => o.isBefore(u, "day"), this.isAfterMonth = (o, u) => o.isAfter(u, "month"), this.isBeforeMonth = (o, u) => o.isBefore(u, "month"), this.isBeforeYear = (o, u) => o.isBefore(u, "year"), this.isAfterYear = (o, u) => o.isAfter(u, "year"), this.startOfDay = (o) => o.startOf("day"), this.endOfDay = (o) => o.endOf("day"), this.format = (o, u) => this.formatByString(o, this.formats[u]), this.formatByString = (o, u) => this.dayjs(o).format(u), this.formatNumber = (o) => o, this.getHours = (o) => o.hour(), this.addSeconds = (o, u) => u < 0 ? o.subtract(Math.abs(u), "second") : o.add(u, "second"), this.addMinutes = (o, u) => u < 0 ? o.subtract(Math.abs(u), "minute") : o.add(u, "minute"), this.addHours = (o, u) => u < 0 ? o.subtract(Math.abs(u), "hour") : o.add(u, "hour"), this.addDays = (o, u) => u < 0 ? o.subtract(Math.abs(u), "day") : o.add(u, "day"), this.addWeeks = (o, u) => u < 0 ? o.subtract(Math.abs(u), "week") : o.add(u, "week"), this.addMonths = (o, u) => u < 0 ? o.subtract(Math.abs(u), "month") : o.add(u, "month"), this.addYears = (o, u) => u < 0 ? o.subtract(Math.abs(u), "year") : o.add(u, "year"), this.setMonth = (o, u) => o.set("month", u), this.setHours = (o, u) => o.set("hour", u), this.getMinutes = (o) => o.minute(), this.setMinutes = (o, u) => o.set("minute", u), this.getSeconds = (o) => o.second(), this.setSeconds = (o, u) => o.set("second", u), this.getMonth = (o) => o.month(), this.getDate = (o) => o.date(), this.setDate = (o, u) => o.set("date", u), this.getDaysInMonth = (o) => o.daysInMonth(), this.isSameDay = (o, u) => o.isSame(u, "day"), this.isSameMonth = (o, u) => o.isSame(u, "month"), this.isSameYear = (o, u) => o.isSame(u, "year"), this.isSameHour = (o, u) => o.isSame(u, "hour"), this.getMeridiemText = (o) => o === "am" ? "AM" : "PM", this.startOfYear = (o) => o.startOf("year"), this.endOfYear = (o) => o.endOf("year"), this.startOfMonth = (o) => o.startOf("month"), this.endOfMonth = (o) => o.endOf("month"), this.startOfWeek = (o) => o.startOf("week"), this.endOfWeek = (o) => o.endOf("week"), this.getNextMonth = (o) => o.add(1, "month"), this.getPreviousMonth = (o) => o.subtract(1, "month"), this.getMonthArray = (o) => {
      const f = [o.startOf("year")];
      for (; f.length < 12; ) {
        const l = f[f.length - 1];
        f.push(this.getNextMonth(l));
      }
      return f;
    }, this.getYear = (o) => o.year(), this.setYear = (o, u) => o.set("year", u), this.mergeDateAndTime = (o, u) => o.hour(u.hour()).minute(u.minute()).second(u.second()), this.getWeekdays = () => {
      const o = this.dayjs().startOf("week");
      return [0, 1, 2, 3, 4, 5, 6].map((u) => this.formatByString(o.add(u, "day"), "dd"));
    }, this.isEqual = (o, u) => o === null && u === null ? !0 : this.dayjs(o).isSame(u), this.getWeekArray = (o) => {
      const u = this.dayjs(o).startOf("month").startOf("week"), f = this.dayjs(o).endOf("month").endOf("week");
      let l = 0, y = u;
      const p = [];
      for (; y.isBefore(f); ) {
        const g = Math.floor(l / 7);
        p[g] = p[g] || [], p[g].push(y), y = y.add(1, "day"), l += 1;
      }
      return p;
    }, this.getYearRange = (o, u) => {
      const f = this.dayjs(o).startOf("year"), l = this.dayjs(u).endOf("year"), y = [];
      let p = f;
      for (; p.isBefore(l); )
        y.push(p), p = p.add(1, "year");
      return y;
    }, this.isWithinRange = (o, [u, f]) => o.isBetween(u, f, null, "[]"), this.rawDayJsInstance = s || Pt, this.dayjs = ps(this.rawDayJsInstance, t), this.locale = t, this.formats = Object.assign({}, ms, r);
  }
}
var Br = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s(Ar());
  })(dt, function(r) {
    function s(f) {
      return f && typeof f == "object" && "default" in f ? f : { default: f };
    }
    var o = s(r), u = { name: "en-au", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), weekStart: 1, weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), ordinal: function(f) {
      return f;
    }, formats: { LT: "h:mm A", LTS: "h:mm:ss A", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY h:mm A", LLLL: "dddd, D MMMM YYYY h:mm A" }, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" } };
    return o.default.locale(u, null, !0), u;
  });
})(Br);
var ys = Br.exports;
const ws = /* @__PURE__ */ Xe(ys), vs = {
  adapter: gs,
  locale: {
    "en-au": ws
  }
}, bs = {
  global: {
    elevation: 0
  },
  VAlert: {
    border: "none",
    variant: "tonal",
    rounded: "md"
  },
  VNavigationDrawer: {
    railWidth: 80,
    scrim: !0,
    mobileBreakpoint: "lg",
    VList: {
      bgColor: "surface",
      nav: !0
    }
  },
  VBtn: {
    rounded: "pill"
  },
  VTextarea: {
    rows: 4,
    counter: 100,
    variant: "outlined",
    color: "primary",
    persistentPlaceholder: !0,
    persistentHint: !0
  },
  VTextField: {
    density: "comfortable",
    variant: "outlined",
    color: "primary",
    persistentPlaceholder: !0,
    persistentHint: !0,
    persistentCounter: !0
  },
  VSelect: {
    variant: "outlined",
    color: "primary",
    persistentPlaceholder: !0,
    persistentHint: !0
  },
  VFileInput: {
    variant: "outlined",
    color: "primary",
    prependIcon: "",
    prependInnerIcon: Cr,
    chips: !0,
    VChip: {
      variant: "outlined"
    }
  },
  VCheckbox: {
    color: "primary",
    persistentHint: !0
  },
  VList: {
    bgColor: "surface",
    VListItem: {
      color: "info"
    }
  },
  VCombobox: {
    variant: "outlined",
    color: "primary",
    persistentPlaceholder: !0,
    persistentHint: !0
  },
  VAutocomplete: {
    variant: "outlined",
    color: "primary",
    persistentPlaceholder: !0,
    persistentHint: !0
  },
  VChip: {
    label: !0,
    rounded: "md"
  },
  VRadio: {
    color: "primary"
  },
  VSwitch: {
    color: "success",
    inset: !0
  },
  VSlider: {
    color: "primary"
  },
  VRangeSlider: {
    color: "primary"
  },
  VAppBar: {
    color: "primary",
    flat: !0
  },
  VDatePicker: {
    color: "primary"
  },
  VDataTable: {
    color: "primary"
  },
  VTabs: {
    color: "primary",
    sliderColor: "error",
    VBtn: {
      rounded: "0"
    }
  }
}, Mr = {
  "ads-a-font-weight": 700,
  "ads-a-hover-text-decoration": "none",
  "ads-btn-outlined-border-width": "2px",
  "ads-list-nav-padding-inline": "12px",
  "ads-list-nav-item-border-radius-open": "9999px",
  "ads-list-nav-item-border-radius-closed": "8px",
  "ads-placeholder-opacity": 0.7,
  "ads-label-opacity": 1,
  // remove VLabel's opacity
  "ads-checkbox-opacity": 1,
  // remove VCheckbox::VIcon opacity
  "ads-radio-opacity": 1
  // remove VRadio opacity
}, Ls = {
  dark: !1,
  colors: {
    primary: X.BLUE_01,
    secondary: X.BLUE_04,
    error: X.RED_02,
    info: X.BLUE_02,
    success: X.GREEN_02,
    warning: X.ORANGE_02,
    surface: X.WHITE,
    background: X.GREY_05
  },
  variables: {
    // vuetify overrides
    "medium-emphasis-opacity": 0.7,
    "disabled-opacity": 0.55,
    "theme-on-background": X.GREY_01,
    "theme-on-secondary": X.GREY_01,
    "theme-on-secondary-darken-1": X.GREY_01,
    "theme-on-surface": X.GREY_01,
    "theme-on-surface-light": X.GREY_01,
    "theme-on-surface-bright": X.GREY_01,
    // global vars
    ...Mr,
    // theme-specific vars
    "ads-a-color": X.BLUE_02,
    "ads-chip-content-color": X.GREY_02
  }
}, Es = {
  dark: !0,
  colors: {
    primary: X.BLUE_03,
    secondary: X.BLUE_04,
    error: X.RED_03,
    info: X.BLUE_03,
    success: X.GREEN_03,
    warning: X.ORANGE_03
  },
  variables: {
    // vuetify overrides
    "medium-emphasis-opacity": 0.7,
    "disabled-opacity": 0.55,
    "theme-on-background": X.GREY_05,
    "theme-on-secondary": X.GREY_01,
    "theme-on-secondary-darken-1": X.GREY_05,
    "theme-on-surface": X.GREY_05,
    "theme-on-surface-light": X.GREY_05,
    "theme-on-surface-bright": X.GREY_01,
    // global vars
    ...Mr,
    // theme-specific vars
    "ads-a-color": X.BLUE_03,
    "ads-chip-content-color": X.GREY_04,
    "ads-chip-underlay-opacity": 0.25
  }
}, Ss = {
  defaultTheme: "light",
  themes: {
    light: Ls,
    dark: Es
  },
  variations: {
    colors: ["primary", "secondary"],
    lighten: 0,
    darken: 1
  }
};
xt.dataFooter.itemsPerPageText = xt.dataTable.itemsPerPageText;
const Cs = {
  locale: "en-au",
  fallback: "en",
  messages: {
    "en-au": xt,
    en: xt
  }
}, cu = {
  date: vs,
  defaults: bs,
  theme: Ss,
  icons: ss,
  locale: Cs
};
var kr = { exports: {} }, gn = {}, yn = {};
Object.defineProperty(yn, "__esModule", { value: !0 });
function As(e) {
  var t = 4, r = e.length, s = r % t;
  if (!s)
    return e;
  var o = r, u = t - s, f = r + u, l = Buffer.alloc(f);
  for (l.write(e); u--; )
    l.write("=", o++);
  return l.toString();
}
yn.default = As;
Object.defineProperty(gn, "__esModule", { value: !0 });
var _s = yn;
function Tr(e, t) {
  return t === void 0 && (t = "utf8"), Buffer.isBuffer(e) ? rn(e.toString("base64")) : rn(Buffer.from(e, t).toString("base64"));
}
function xs(e, t) {
  return t === void 0 && (t = "utf8"), Buffer.from(wn(e), "base64").toString(t);
}
function wn(e) {
  return e = e.toString(), _s.default(e).replace(/\-/g, "+").replace(/_/g, "/");
}
function rn(e) {
  return e.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function Is(e) {
  return Buffer.from(wn(e), "base64");
}
var Ke = Tr;
Ke.encode = Tr;
Ke.decode = xs;
Ke.toBase64 = wn;
Ke.fromBase64 = rn;
Ke.toBuffer = Is;
gn.default = Ke;
(function(e) {
  e.exports = gn.default, e.exports.default = e.exports;
})(kr);
var Bs = kr.exports;
const Ms = /* @__PURE__ */ Xe(Bs);
var Or = {}, Nt = {};
Nt.byteLength = Os;
Nt.toByteArray = Ds;
Nt.fromByteArray = Ns;
var Me = [], Ee = [], ks = typeof Uint8Array < "u" ? Uint8Array : Array, qt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var $e = 0, Ts = qt.length; $e < Ts; ++$e)
  Me[$e] = qt[$e], Ee[qt.charCodeAt($e)] = $e;
Ee["-".charCodeAt(0)] = 62;
Ee["_".charCodeAt(0)] = 63;
function Fr(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  r === -1 && (r = t);
  var s = r === t ? 0 : 4 - r % 4;
  return [r, s];
}
function Os(e) {
  var t = Fr(e), r = t[0], s = t[1];
  return (r + s) * 3 / 4 - s;
}
function Fs(e, t, r) {
  return (t + r) * 3 / 4 - r;
}
function Ds(e) {
  var t, r = Fr(e), s = r[0], o = r[1], u = new ks(Fs(e, s, o)), f = 0, l = o > 0 ? s - 4 : s, y;
  for (y = 0; y < l; y += 4)
    t = Ee[e.charCodeAt(y)] << 18 | Ee[e.charCodeAt(y + 1)] << 12 | Ee[e.charCodeAt(y + 2)] << 6 | Ee[e.charCodeAt(y + 3)], u[f++] = t >> 16 & 255, u[f++] = t >> 8 & 255, u[f++] = t & 255;
  return o === 2 && (t = Ee[e.charCodeAt(y)] << 2 | Ee[e.charCodeAt(y + 1)] >> 4, u[f++] = t & 255), o === 1 && (t = Ee[e.charCodeAt(y)] << 10 | Ee[e.charCodeAt(y + 1)] << 4 | Ee[e.charCodeAt(y + 2)] >> 2, u[f++] = t >> 8 & 255, u[f++] = t & 255), u;
}
function Rs(e) {
  return Me[e >> 18 & 63] + Me[e >> 12 & 63] + Me[e >> 6 & 63] + Me[e & 63];
}
function Ps(e, t, r) {
  for (var s, o = [], u = t; u < r; u += 3)
    s = (e[u] << 16 & 16711680) + (e[u + 1] << 8 & 65280) + (e[u + 2] & 255), o.push(Rs(s));
  return o.join("");
}
function Ns(e) {
  for (var t, r = e.length, s = r % 3, o = [], u = 16383, f = 0, l = r - s; f < l; f += u)
    o.push(Ps(e, f, f + u > l ? l : f + u));
  return s === 1 ? (t = e[r - 1], o.push(
    Me[t >> 2] + Me[t << 4 & 63] + "=="
  )) : s === 2 && (t = (e[r - 2] << 8) + e[r - 1], o.push(
    Me[t >> 10] + Me[t >> 4 & 63] + Me[t << 2 & 63] + "="
  )), o.join("");
}
var vn = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
vn.read = function(e, t, r, s, o) {
  var u, f, l = o * 8 - s - 1, y = (1 << l) - 1, p = y >> 1, g = -7, b = r ? o - 1 : 0, O = r ? -1 : 1, M = e[t + b];
  for (b += O, u = M & (1 << -g) - 1, M >>= -g, g += l; g > 0; u = u * 256 + e[t + b], b += O, g -= 8)
    ;
  for (f = u & (1 << -g) - 1, u >>= -g, g += s; g > 0; f = f * 256 + e[t + b], b += O, g -= 8)
    ;
  if (u === 0)
    u = 1 - p;
  else {
    if (u === y)
      return f ? NaN : (M ? -1 : 1) * (1 / 0);
    f = f + Math.pow(2, s), u = u - p;
  }
  return (M ? -1 : 1) * f * Math.pow(2, u - s);
};
vn.write = function(e, t, r, s, o, u) {
  var f, l, y, p = u * 8 - o - 1, g = (1 << p) - 1, b = g >> 1, O = o === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, M = s ? 0 : u - 1, I = s ? 1 : -1, S = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (l = isNaN(t) ? 1 : 0, f = g) : (f = Math.floor(Math.log(t) / Math.LN2), t * (y = Math.pow(2, -f)) < 1 && (f--, y *= 2), f + b >= 1 ? t += O / y : t += O * Math.pow(2, 1 - b), t * y >= 2 && (f++, y /= 2), f + b >= g ? (l = 0, f = g) : f + b >= 1 ? (l = (t * y - 1) * Math.pow(2, o), f = f + b) : (l = t * Math.pow(2, b - 1) * Math.pow(2, o), f = 0)); o >= 8; e[r + M] = l & 255, M += I, l /= 256, o -= 8)
    ;
  for (f = f << o | l, p += o; p > 0; e[r + M] = f & 255, M += I, f /= 256, p -= 8)
    ;
  e[r + M - I] |= S * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = Nt, r = vn, s = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = l, e.SlowBuffer = $, e.INSPECT_MAX_BYTES = 50;
  const o = 2147483647;
  e.kMaxLength = o, l.TYPED_ARRAY_SUPPORT = u(), !l.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function u() {
    try {
      const c = new Uint8Array(1), n = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(n, Uint8Array.prototype), Object.setPrototypeOf(c, n), c.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(l.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (l.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(l.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (l.isBuffer(this))
        return this.byteOffset;
    }
  });
  function f(c) {
    if (c > o)
      throw new RangeError('The value "' + c + '" is invalid for option "size"');
    const n = new Uint8Array(c);
    return Object.setPrototypeOf(n, l.prototype), n;
  }
  function l(c, n, i) {
    if (typeof c == "number") {
      if (typeof n == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return b(c);
    }
    return y(c, n, i);
  }
  l.poolSize = 8192;
  function y(c, n, i) {
    if (typeof c == "string")
      return O(c, n);
    if (ArrayBuffer.isView(c))
      return I(c);
    if (c == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof c
      );
    if (Le(c, ArrayBuffer) || c && Le(c.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Le(c, SharedArrayBuffer) || c && Le(c.buffer, SharedArrayBuffer)))
      return S(c, n, i);
    if (typeof c == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const h = c.valueOf && c.valueOf();
    if (h != null && h !== c)
      return l.from(h, n, i);
    const m = P(c);
    if (m)
      return m;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof c[Symbol.toPrimitive] == "function")
      return l.from(c[Symbol.toPrimitive]("string"), n, i);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof c
    );
  }
  l.from = function(c, n, i) {
    return y(c, n, i);
  }, Object.setPrototypeOf(l.prototype, Uint8Array.prototype), Object.setPrototypeOf(l, Uint8Array);
  function p(c) {
    if (typeof c != "number")
      throw new TypeError('"size" argument must be of type number');
    if (c < 0)
      throw new RangeError('The value "' + c + '" is invalid for option "size"');
  }
  function g(c, n, i) {
    return p(c), c <= 0 ? f(c) : n !== void 0 ? typeof i == "string" ? f(c).fill(n, i) : f(c).fill(n) : f(c);
  }
  l.alloc = function(c, n, i) {
    return g(c, n, i);
  };
  function b(c) {
    return p(c), f(c < 0 ? 0 : N(c) | 0);
  }
  l.allocUnsafe = function(c) {
    return b(c);
  }, l.allocUnsafeSlow = function(c) {
    return b(c);
  };
  function O(c, n) {
    if ((typeof n != "string" || n === "") && (n = "utf8"), !l.isEncoding(n))
      throw new TypeError("Unknown encoding: " + n);
    const i = G(c, n) | 0;
    let h = f(i);
    const m = h.write(c, n);
    return m !== i && (h = h.slice(0, m)), h;
  }
  function M(c) {
    const n = c.length < 0 ? 0 : N(c.length) | 0, i = f(n);
    for (let h = 0; h < n; h += 1)
      i[h] = c[h] & 255;
    return i;
  }
  function I(c) {
    if (Le(c, Uint8Array)) {
      const n = new Uint8Array(c);
      return S(n.buffer, n.byteOffset, n.byteLength);
    }
    return M(c);
  }
  function S(c, n, i) {
    if (n < 0 || c.byteLength < n)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (c.byteLength < n + (i || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let h;
    return n === void 0 && i === void 0 ? h = new Uint8Array(c) : i === void 0 ? h = new Uint8Array(c, n) : h = new Uint8Array(c, n, i), Object.setPrototypeOf(h, l.prototype), h;
  }
  function P(c) {
    if (l.isBuffer(c)) {
      const n = N(c.length) | 0, i = f(n);
      return i.length === 0 || c.copy(i, 0, 0, n), i;
    }
    if (c.length !== void 0)
      return typeof c.length != "number" || tt(c.length) ? f(0) : M(c);
    if (c.type === "Buffer" && Array.isArray(c.data))
      return M(c.data);
  }
  function N(c) {
    if (c >= o)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o.toString(16) + " bytes");
    return c | 0;
  }
  function $(c) {
    return +c != c && (c = 0), l.alloc(+c);
  }
  l.isBuffer = function(n) {
    return n != null && n._isBuffer === !0 && n !== l.prototype;
  }, l.compare = function(n, i) {
    if (Le(n, Uint8Array) && (n = l.from(n, n.offset, n.byteLength)), Le(i, Uint8Array) && (i = l.from(i, i.offset, i.byteLength)), !l.isBuffer(n) || !l.isBuffer(i))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (n === i)
      return 0;
    let h = n.length, m = i.length;
    for (let a = 0, d = Math.min(h, m); a < d; ++a)
      if (n[a] !== i[a]) {
        h = n[a], m = i[a];
        break;
      }
    return h < m ? -1 : m < h ? 1 : 0;
  }, l.isEncoding = function(n) {
    switch (String(n).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, l.concat = function(n, i) {
    if (!Array.isArray(n))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (n.length === 0)
      return l.alloc(0);
    let h;
    if (i === void 0)
      for (i = 0, h = 0; h < n.length; ++h)
        i += n[h].length;
    const m = l.allocUnsafe(i);
    let a = 0;
    for (h = 0; h < n.length; ++h) {
      let d = n[h];
      if (Le(d, Uint8Array))
        a + d.length > m.length ? (l.isBuffer(d) || (d = l.from(d)), d.copy(m, a)) : Uint8Array.prototype.set.call(
          m,
          d,
          a
        );
      else if (l.isBuffer(d))
        d.copy(m, a);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      a += d.length;
    }
    return m;
  };
  function G(c, n) {
    if (l.isBuffer(c))
      return c.length;
    if (ArrayBuffer.isView(c) || Le(c, ArrayBuffer))
      return c.byteLength;
    if (typeof c != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof c
      );
    const i = c.length, h = arguments.length > 2 && arguments[2] === !0;
    if (!h && i === 0)
      return 0;
    let m = !1;
    for (; ; )
      switch (n) {
        case "ascii":
        case "latin1":
        case "binary":
          return i;
        case "utf8":
        case "utf-8":
          return et(c).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return i * 2;
        case "hex":
          return i >>> 1;
        case "base64":
          return gt(c).length;
        default:
          if (m)
            return h ? -1 : et(c).length;
          n = ("" + n).toLowerCase(), m = !0;
      }
  }
  l.byteLength = G;
  function Y(c, n, i) {
    let h = !1;
    if ((n === void 0 || n < 0) && (n = 0), n > this.length || ((i === void 0 || i > this.length) && (i = this.length), i <= 0) || (i >>>= 0, n >>>= 0, i <= n))
      return "";
    for (c || (c = "utf8"); ; )
      switch (c) {
        case "hex":
          return F(this, n, i);
        case "utf8":
        case "utf-8":
          return T(this, n, i);
        case "ascii":
          return k(this, n, i);
        case "latin1":
        case "binary":
          return A(this, n, i);
        case "base64":
          return W(this, n, i);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return R(this, n, i);
        default:
          if (h)
            throw new TypeError("Unknown encoding: " + c);
          c = (c + "").toLowerCase(), h = !0;
      }
  }
  l.prototype._isBuffer = !0;
  function te(c, n, i) {
    const h = c[n];
    c[n] = c[i], c[i] = h;
  }
  l.prototype.swap16 = function() {
    const n = this.length;
    if (n % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let i = 0; i < n; i += 2)
      te(this, i, i + 1);
    return this;
  }, l.prototype.swap32 = function() {
    const n = this.length;
    if (n % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let i = 0; i < n; i += 4)
      te(this, i, i + 3), te(this, i + 1, i + 2);
    return this;
  }, l.prototype.swap64 = function() {
    const n = this.length;
    if (n % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let i = 0; i < n; i += 8)
      te(this, i, i + 7), te(this, i + 1, i + 6), te(this, i + 2, i + 5), te(this, i + 3, i + 4);
    return this;
  }, l.prototype.toString = function() {
    const n = this.length;
    return n === 0 ? "" : arguments.length === 0 ? T(this, 0, n) : Y.apply(this, arguments);
  }, l.prototype.toLocaleString = l.prototype.toString, l.prototype.equals = function(n) {
    if (!l.isBuffer(n))
      throw new TypeError("Argument must be a Buffer");
    return this === n ? !0 : l.compare(this, n) === 0;
  }, l.prototype.inspect = function() {
    let n = "";
    const i = e.INSPECT_MAX_BYTES;
    return n = this.toString("hex", 0, i).replace(/(.{2})/g, "$1 ").trim(), this.length > i && (n += " ... "), "<Buffer " + n + ">";
  }, s && (l.prototype[s] = l.prototype.inspect), l.prototype.compare = function(n, i, h, m, a) {
    if (Le(n, Uint8Array) && (n = l.from(n, n.offset, n.byteLength)), !l.isBuffer(n))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof n
      );
    if (i === void 0 && (i = 0), h === void 0 && (h = n ? n.length : 0), m === void 0 && (m = 0), a === void 0 && (a = this.length), i < 0 || h > n.length || m < 0 || a > this.length)
      throw new RangeError("out of range index");
    if (m >= a && i >= h)
      return 0;
    if (m >= a)
      return -1;
    if (i >= h)
      return 1;
    if (i >>>= 0, h >>>= 0, m >>>= 0, a >>>= 0, this === n)
      return 0;
    let d = a - m, w = h - i;
    const v = Math.min(d, w), E = this.slice(m, a), x = n.slice(i, h);
    for (let B = 0; B < v; ++B)
      if (E[B] !== x[B]) {
        d = E[B], w = x[B];
        break;
      }
    return d < w ? -1 : w < d ? 1 : 0;
  };
  function ie(c, n, i, h, m) {
    if (c.length === 0)
      return -1;
    if (typeof i == "string" ? (h = i, i = 0) : i > 2147483647 ? i = 2147483647 : i < -2147483648 && (i = -2147483648), i = +i, tt(i) && (i = m ? 0 : c.length - 1), i < 0 && (i = c.length + i), i >= c.length) {
      if (m)
        return -1;
      i = c.length - 1;
    } else if (i < 0)
      if (m)
        i = 0;
      else
        return -1;
    if (typeof n == "string" && (n = l.from(n, h)), l.isBuffer(n))
      return n.length === 0 ? -1 : q(c, n, i, h, m);
    if (typeof n == "number")
      return n = n & 255, typeof Uint8Array.prototype.indexOf == "function" ? m ? Uint8Array.prototype.indexOf.call(c, n, i) : Uint8Array.prototype.lastIndexOf.call(c, n, i) : q(c, [n], i, h, m);
    throw new TypeError("val must be string, number or Buffer");
  }
  function q(c, n, i, h, m) {
    let a = 1, d = c.length, w = n.length;
    if (h !== void 0 && (h = String(h).toLowerCase(), h === "ucs2" || h === "ucs-2" || h === "utf16le" || h === "utf-16le")) {
      if (c.length < 2 || n.length < 2)
        return -1;
      a = 2, d /= 2, w /= 2, i /= 2;
    }
    function v(x, B) {
      return a === 1 ? x[B] : x.readUInt16BE(B * a);
    }
    let E;
    if (m) {
      let x = -1;
      for (E = i; E < d; E++)
        if (v(c, E) === v(n, x === -1 ? 0 : E - x)) {
          if (x === -1 && (x = E), E - x + 1 === w)
            return x * a;
        } else
          x !== -1 && (E -= E - x), x = -1;
    } else
      for (i + w > d && (i = d - w), E = i; E >= 0; E--) {
        let x = !0;
        for (let B = 0; B < w; B++)
          if (v(c, E + B) !== v(n, B)) {
            x = !1;
            break;
          }
        if (x)
          return E;
      }
    return -1;
  }
  l.prototype.includes = function(n, i, h) {
    return this.indexOf(n, i, h) !== -1;
  }, l.prototype.indexOf = function(n, i, h) {
    return ie(this, n, i, h, !0);
  }, l.prototype.lastIndexOf = function(n, i, h) {
    return ie(this, n, i, h, !1);
  };
  function ae(c, n, i, h) {
    i = Number(i) || 0;
    const m = c.length - i;
    h ? (h = Number(h), h > m && (h = m)) : h = m;
    const a = n.length;
    h > a / 2 && (h = a / 2);
    let d;
    for (d = 0; d < h; ++d) {
      const w = parseInt(n.substr(d * 2, 2), 16);
      if (tt(w))
        return d;
      c[i + d] = w;
    }
    return d;
  }
  function de(c, n, i, h) {
    return Pe(et(n, c.length - i), c, i, h);
  }
  function z(c, n, i, h) {
    return Pe(Yt(n), c, i, h);
  }
  function U(c, n, i, h) {
    return Pe(gt(n), c, i, h);
  }
  function H(c, n, i, h) {
    return Pe(zt(n, c.length - i), c, i, h);
  }
  l.prototype.write = function(n, i, h, m) {
    if (i === void 0)
      m = "utf8", h = this.length, i = 0;
    else if (h === void 0 && typeof i == "string")
      m = i, h = this.length, i = 0;
    else if (isFinite(i))
      i = i >>> 0, isFinite(h) ? (h = h >>> 0, m === void 0 && (m = "utf8")) : (m = h, h = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const a = this.length - i;
    if ((h === void 0 || h > a) && (h = a), n.length > 0 && (h < 0 || i < 0) || i > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    m || (m = "utf8");
    let d = !1;
    for (; ; )
      switch (m) {
        case "hex":
          return ae(this, n, i, h);
        case "utf8":
        case "utf-8":
          return de(this, n, i, h);
        case "ascii":
        case "latin1":
        case "binary":
          return z(this, n, i, h);
        case "base64":
          return U(this, n, i, h);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return H(this, n, i, h);
        default:
          if (d)
            throw new TypeError("Unknown encoding: " + m);
          m = ("" + m).toLowerCase(), d = !0;
      }
  }, l.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function W(c, n, i) {
    return n === 0 && i === c.length ? t.fromByteArray(c) : t.fromByteArray(c.slice(n, i));
  }
  function T(c, n, i) {
    i = Math.min(c.length, i);
    const h = [];
    let m = n;
    for (; m < i; ) {
      const a = c[m];
      let d = null, w = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
      if (m + w <= i) {
        let v, E, x, B;
        switch (w) {
          case 1:
            a < 128 && (d = a);
            break;
          case 2:
            v = c[m + 1], (v & 192) === 128 && (B = (a & 31) << 6 | v & 63, B > 127 && (d = B));
            break;
          case 3:
            v = c[m + 1], E = c[m + 2], (v & 192) === 128 && (E & 192) === 128 && (B = (a & 15) << 12 | (v & 63) << 6 | E & 63, B > 2047 && (B < 55296 || B > 57343) && (d = B));
            break;
          case 4:
            v = c[m + 1], E = c[m + 2], x = c[m + 3], (v & 192) === 128 && (E & 192) === 128 && (x & 192) === 128 && (B = (a & 15) << 18 | (v & 63) << 12 | (E & 63) << 6 | x & 63, B > 65535 && B < 1114112 && (d = B));
        }
      }
      d === null ? (d = 65533, w = 1) : d > 65535 && (d -= 65536, h.push(d >>> 10 & 1023 | 55296), d = 56320 | d & 1023), h.push(d), m += w;
    }
    return C(h);
  }
  const _ = 4096;
  function C(c) {
    const n = c.length;
    if (n <= _)
      return String.fromCharCode.apply(String, c);
    let i = "", h = 0;
    for (; h < n; )
      i += String.fromCharCode.apply(
        String,
        c.slice(h, h += _)
      );
    return i;
  }
  function k(c, n, i) {
    let h = "";
    i = Math.min(c.length, i);
    for (let m = n; m < i; ++m)
      h += String.fromCharCode(c[m] & 127);
    return h;
  }
  function A(c, n, i) {
    let h = "";
    i = Math.min(c.length, i);
    for (let m = n; m < i; ++m)
      h += String.fromCharCode(c[m]);
    return h;
  }
  function F(c, n, i) {
    const h = c.length;
    (!n || n < 0) && (n = 0), (!i || i < 0 || i > h) && (i = h);
    let m = "";
    for (let a = n; a < i; ++a)
      m += Wt[c[a]];
    return m;
  }
  function R(c, n, i) {
    const h = c.slice(n, i);
    let m = "";
    for (let a = 0; a < h.length - 1; a += 2)
      m += String.fromCharCode(h[a] + h[a + 1] * 256);
    return m;
  }
  l.prototype.slice = function(n, i) {
    const h = this.length;
    n = ~~n, i = i === void 0 ? h : ~~i, n < 0 ? (n += h, n < 0 && (n = 0)) : n > h && (n = h), i < 0 ? (i += h, i < 0 && (i = 0)) : i > h && (i = h), i < n && (i = n);
    const m = this.subarray(n, i);
    return Object.setPrototypeOf(m, l.prototype), m;
  };
  function D(c, n, i) {
    if (c % 1 !== 0 || c < 0)
      throw new RangeError("offset is not uint");
    if (c + n > i)
      throw new RangeError("Trying to access beyond buffer length");
  }
  l.prototype.readUintLE = l.prototype.readUIntLE = function(n, i, h) {
    n = n >>> 0, i = i >>> 0, h || D(n, i, this.length);
    let m = this[n], a = 1, d = 0;
    for (; ++d < i && (a *= 256); )
      m += this[n + d] * a;
    return m;
  }, l.prototype.readUintBE = l.prototype.readUIntBE = function(n, i, h) {
    n = n >>> 0, i = i >>> 0, h || D(n, i, this.length);
    let m = this[n + --i], a = 1;
    for (; i > 0 && (a *= 256); )
      m += this[n + --i] * a;
    return m;
  }, l.prototype.readUint8 = l.prototype.readUInt8 = function(n, i) {
    return n = n >>> 0, i || D(n, 1, this.length), this[n];
  }, l.prototype.readUint16LE = l.prototype.readUInt16LE = function(n, i) {
    return n = n >>> 0, i || D(n, 2, this.length), this[n] | this[n + 1] << 8;
  }, l.prototype.readUint16BE = l.prototype.readUInt16BE = function(n, i) {
    return n = n >>> 0, i || D(n, 2, this.length), this[n] << 8 | this[n + 1];
  }, l.prototype.readUint32LE = l.prototype.readUInt32LE = function(n, i) {
    return n = n >>> 0, i || D(n, 4, this.length), (this[n] | this[n + 1] << 8 | this[n + 2] << 16) + this[n + 3] * 16777216;
  }, l.prototype.readUint32BE = l.prototype.readUInt32BE = function(n, i) {
    return n = n >>> 0, i || D(n, 4, this.length), this[n] * 16777216 + (this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3]);
  }, l.prototype.readBigUInt64LE = Ie(function(n) {
    n = n >>> 0, me(n, "offset");
    const i = this[n], h = this[n + 7];
    (i === void 0 || h === void 0) && be(n, this.length - 8);
    const m = i + this[++n] * 2 ** 8 + this[++n] * 2 ** 16 + this[++n] * 2 ** 24, a = this[++n] + this[++n] * 2 ** 8 + this[++n] * 2 ** 16 + h * 2 ** 24;
    return BigInt(m) + (BigInt(a) << BigInt(32));
  }), l.prototype.readBigUInt64BE = Ie(function(n) {
    n = n >>> 0, me(n, "offset");
    const i = this[n], h = this[n + 7];
    (i === void 0 || h === void 0) && be(n, this.length - 8);
    const m = i * 2 ** 24 + this[++n] * 2 ** 16 + this[++n] * 2 ** 8 + this[++n], a = this[++n] * 2 ** 24 + this[++n] * 2 ** 16 + this[++n] * 2 ** 8 + h;
    return (BigInt(m) << BigInt(32)) + BigInt(a);
  }), l.prototype.readIntLE = function(n, i, h) {
    n = n >>> 0, i = i >>> 0, h || D(n, i, this.length);
    let m = this[n], a = 1, d = 0;
    for (; ++d < i && (a *= 256); )
      m += this[n + d] * a;
    return a *= 128, m >= a && (m -= Math.pow(2, 8 * i)), m;
  }, l.prototype.readIntBE = function(n, i, h) {
    n = n >>> 0, i = i >>> 0, h || D(n, i, this.length);
    let m = i, a = 1, d = this[n + --m];
    for (; m > 0 && (a *= 256); )
      d += this[n + --m] * a;
    return a *= 128, d >= a && (d -= Math.pow(2, 8 * i)), d;
  }, l.prototype.readInt8 = function(n, i) {
    return n = n >>> 0, i || D(n, 1, this.length), this[n] & 128 ? (255 - this[n] + 1) * -1 : this[n];
  }, l.prototype.readInt16LE = function(n, i) {
    n = n >>> 0, i || D(n, 2, this.length);
    const h = this[n] | this[n + 1] << 8;
    return h & 32768 ? h | 4294901760 : h;
  }, l.prototype.readInt16BE = function(n, i) {
    n = n >>> 0, i || D(n, 2, this.length);
    const h = this[n + 1] | this[n] << 8;
    return h & 32768 ? h | 4294901760 : h;
  }, l.prototype.readInt32LE = function(n, i) {
    return n = n >>> 0, i || D(n, 4, this.length), this[n] | this[n + 1] << 8 | this[n + 2] << 16 | this[n + 3] << 24;
  }, l.prototype.readInt32BE = function(n, i) {
    return n = n >>> 0, i || D(n, 4, this.length), this[n] << 24 | this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3];
  }, l.prototype.readBigInt64LE = Ie(function(n) {
    n = n >>> 0, me(n, "offset");
    const i = this[n], h = this[n + 7];
    (i === void 0 || h === void 0) && be(n, this.length - 8);
    const m = this[n + 4] + this[n + 5] * 2 ** 8 + this[n + 6] * 2 ** 16 + (h << 24);
    return (BigInt(m) << BigInt(32)) + BigInt(i + this[++n] * 2 ** 8 + this[++n] * 2 ** 16 + this[++n] * 2 ** 24);
  }), l.prototype.readBigInt64BE = Ie(function(n) {
    n = n >>> 0, me(n, "offset");
    const i = this[n], h = this[n + 7];
    (i === void 0 || h === void 0) && be(n, this.length - 8);
    const m = (i << 24) + // Overflow
    this[++n] * 2 ** 16 + this[++n] * 2 ** 8 + this[++n];
    return (BigInt(m) << BigInt(32)) + BigInt(this[++n] * 2 ** 24 + this[++n] * 2 ** 16 + this[++n] * 2 ** 8 + h);
  }), l.prototype.readFloatLE = function(n, i) {
    return n = n >>> 0, i || D(n, 4, this.length), r.read(this, n, !0, 23, 4);
  }, l.prototype.readFloatBE = function(n, i) {
    return n = n >>> 0, i || D(n, 4, this.length), r.read(this, n, !1, 23, 4);
  }, l.prototype.readDoubleLE = function(n, i) {
    return n = n >>> 0, i || D(n, 8, this.length), r.read(this, n, !0, 52, 8);
  }, l.prototype.readDoubleBE = function(n, i) {
    return n = n >>> 0, i || D(n, 8, this.length), r.read(this, n, !1, 52, 8);
  };
  function V(c, n, i, h, m, a) {
    if (!l.isBuffer(c))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (n > m || n < a)
      throw new RangeError('"value" argument is out of bounds');
    if (i + h > c.length)
      throw new RangeError("Index out of range");
  }
  l.prototype.writeUintLE = l.prototype.writeUIntLE = function(n, i, h, m) {
    if (n = +n, i = i >>> 0, h = h >>> 0, !m) {
      const w = Math.pow(2, 8 * h) - 1;
      V(this, n, i, h, w, 0);
    }
    let a = 1, d = 0;
    for (this[i] = n & 255; ++d < h && (a *= 256); )
      this[i + d] = n / a & 255;
    return i + h;
  }, l.prototype.writeUintBE = l.prototype.writeUIntBE = function(n, i, h, m) {
    if (n = +n, i = i >>> 0, h = h >>> 0, !m) {
      const w = Math.pow(2, 8 * h) - 1;
      V(this, n, i, h, w, 0);
    }
    let a = h - 1, d = 1;
    for (this[i + a] = n & 255; --a >= 0 && (d *= 256); )
      this[i + a] = n / d & 255;
    return i + h;
  }, l.prototype.writeUint8 = l.prototype.writeUInt8 = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 1, 255, 0), this[i] = n & 255, i + 1;
  }, l.prototype.writeUint16LE = l.prototype.writeUInt16LE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 2, 65535, 0), this[i] = n & 255, this[i + 1] = n >>> 8, i + 2;
  }, l.prototype.writeUint16BE = l.prototype.writeUInt16BE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 2, 65535, 0), this[i] = n >>> 8, this[i + 1] = n & 255, i + 2;
  }, l.prototype.writeUint32LE = l.prototype.writeUInt32LE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 4, 4294967295, 0), this[i + 3] = n >>> 24, this[i + 2] = n >>> 16, this[i + 1] = n >>> 8, this[i] = n & 255, i + 4;
  }, l.prototype.writeUint32BE = l.prototype.writeUInt32BE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 4, 4294967295, 0), this[i] = n >>> 24, this[i + 1] = n >>> 16, this[i + 2] = n >>> 8, this[i + 3] = n & 255, i + 4;
  };
  function ee(c, n, i, h, m) {
    we(n, h, m, c, i, 7);
    let a = Number(n & BigInt(4294967295));
    c[i++] = a, a = a >> 8, c[i++] = a, a = a >> 8, c[i++] = a, a = a >> 8, c[i++] = a;
    let d = Number(n >> BigInt(32) & BigInt(4294967295));
    return c[i++] = d, d = d >> 8, c[i++] = d, d = d >> 8, c[i++] = d, d = d >> 8, c[i++] = d, i;
  }
  function ne(c, n, i, h, m) {
    we(n, h, m, c, i, 7);
    let a = Number(n & BigInt(4294967295));
    c[i + 7] = a, a = a >> 8, c[i + 6] = a, a = a >> 8, c[i + 5] = a, a = a >> 8, c[i + 4] = a;
    let d = Number(n >> BigInt(32) & BigInt(4294967295));
    return c[i + 3] = d, d = d >> 8, c[i + 2] = d, d = d >> 8, c[i + 1] = d, d = d >> 8, c[i] = d, i + 8;
  }
  l.prototype.writeBigUInt64LE = Ie(function(n, i = 0) {
    return ee(this, n, i, BigInt(0), BigInt("0xffffffffffffffff"));
  }), l.prototype.writeBigUInt64BE = Ie(function(n, i = 0) {
    return ne(this, n, i, BigInt(0), BigInt("0xffffffffffffffff"));
  }), l.prototype.writeIntLE = function(n, i, h, m) {
    if (n = +n, i = i >>> 0, !m) {
      const v = Math.pow(2, 8 * h - 1);
      V(this, n, i, h, v - 1, -v);
    }
    let a = 0, d = 1, w = 0;
    for (this[i] = n & 255; ++a < h && (d *= 256); )
      n < 0 && w === 0 && this[i + a - 1] !== 0 && (w = 1), this[i + a] = (n / d >> 0) - w & 255;
    return i + h;
  }, l.prototype.writeIntBE = function(n, i, h, m) {
    if (n = +n, i = i >>> 0, !m) {
      const v = Math.pow(2, 8 * h - 1);
      V(this, n, i, h, v - 1, -v);
    }
    let a = h - 1, d = 1, w = 0;
    for (this[i + a] = n & 255; --a >= 0 && (d *= 256); )
      n < 0 && w === 0 && this[i + a + 1] !== 0 && (w = 1), this[i + a] = (n / d >> 0) - w & 255;
    return i + h;
  }, l.prototype.writeInt8 = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 1, 127, -128), n < 0 && (n = 255 + n + 1), this[i] = n & 255, i + 1;
  }, l.prototype.writeInt16LE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 2, 32767, -32768), this[i] = n & 255, this[i + 1] = n >>> 8, i + 2;
  }, l.prototype.writeInt16BE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 2, 32767, -32768), this[i] = n >>> 8, this[i + 1] = n & 255, i + 2;
  }, l.prototype.writeInt32LE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 4, 2147483647, -2147483648), this[i] = n & 255, this[i + 1] = n >>> 8, this[i + 2] = n >>> 16, this[i + 3] = n >>> 24, i + 4;
  }, l.prototype.writeInt32BE = function(n, i, h) {
    return n = +n, i = i >>> 0, h || V(this, n, i, 4, 2147483647, -2147483648), n < 0 && (n = 4294967295 + n + 1), this[i] = n >>> 24, this[i + 1] = n >>> 16, this[i + 2] = n >>> 8, this[i + 3] = n & 255, i + 4;
  }, l.prototype.writeBigInt64LE = Ie(function(n, i = 0) {
    return ee(this, n, i, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), l.prototype.writeBigInt64BE = Ie(function(n, i = 0) {
    return ne(this, n, i, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ue(c, n, i, h, m, a) {
    if (i + h > c.length)
      throw new RangeError("Index out of range");
    if (i < 0)
      throw new RangeError("Index out of range");
  }
  function ve(c, n, i, h, m) {
    return n = +n, i = i >>> 0, m || ue(c, n, i, 4), r.write(c, n, i, h, 23, 4), i + 4;
  }
  l.prototype.writeFloatLE = function(n, i, h) {
    return ve(this, n, i, !0, h);
  }, l.prototype.writeFloatBE = function(n, i, h) {
    return ve(this, n, i, !1, h);
  };
  function pe(c, n, i, h, m) {
    return n = +n, i = i >>> 0, m || ue(c, n, i, 8), r.write(c, n, i, h, 52, 8), i + 8;
  }
  l.prototype.writeDoubleLE = function(n, i, h) {
    return pe(this, n, i, !0, h);
  }, l.prototype.writeDoubleBE = function(n, i, h) {
    return pe(this, n, i, !1, h);
  }, l.prototype.copy = function(n, i, h, m) {
    if (!l.isBuffer(n))
      throw new TypeError("argument should be a Buffer");
    if (h || (h = 0), !m && m !== 0 && (m = this.length), i >= n.length && (i = n.length), i || (i = 0), m > 0 && m < h && (m = h), m === h || n.length === 0 || this.length === 0)
      return 0;
    if (i < 0)
      throw new RangeError("targetStart out of bounds");
    if (h < 0 || h >= this.length)
      throw new RangeError("Index out of range");
    if (m < 0)
      throw new RangeError("sourceEnd out of bounds");
    m > this.length && (m = this.length), n.length - i < m - h && (m = n.length - i + h);
    const a = m - h;
    return this === n && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(i, h, m) : Uint8Array.prototype.set.call(
      n,
      this.subarray(h, m),
      i
    ), a;
  }, l.prototype.fill = function(n, i, h, m) {
    if (typeof n == "string") {
      if (typeof i == "string" ? (m = i, i = 0, h = this.length) : typeof h == "string" && (m = h, h = this.length), m !== void 0 && typeof m != "string")
        throw new TypeError("encoding must be a string");
      if (typeof m == "string" && !l.isEncoding(m))
        throw new TypeError("Unknown encoding: " + m);
      if (n.length === 1) {
        const d = n.charCodeAt(0);
        (m === "utf8" && d < 128 || m === "latin1") && (n = d);
      }
    } else
      typeof n == "number" ? n = n & 255 : typeof n == "boolean" && (n = Number(n));
    if (i < 0 || this.length < i || this.length < h)
      throw new RangeError("Out of range index");
    if (h <= i)
      return this;
    i = i >>> 0, h = h === void 0 ? this.length : h >>> 0, n || (n = 0);
    let a;
    if (typeof n == "number")
      for (a = i; a < h; ++a)
        this[a] = n;
    else {
      const d = l.isBuffer(n) ? n : l.from(n, m), w = d.length;
      if (w === 0)
        throw new TypeError('The value "' + n + '" is invalid for argument "value"');
      for (a = 0; a < h - i; ++a)
        this[a + i] = d[a % w];
    }
    return this;
  };
  const ce = {};
  function le(c, n, i) {
    ce[c] = class extends i {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: n.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${c}]`, this.stack, delete this.name;
      }
      get code() {
        return c;
      }
      set code(m) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: m,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${c}]: ${this.message}`;
      }
    };
  }
  le(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(c) {
      return c ? `${c} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), le(
    "ERR_INVALID_ARG_TYPE",
    function(c, n) {
      return `The "${c}" argument must be of type number. Received type ${typeof n}`;
    },
    TypeError
  ), le(
    "ERR_OUT_OF_RANGE",
    function(c, n, i) {
      let h = `The value of "${c}" is out of range.`, m = i;
      return Number.isInteger(i) && Math.abs(i) > 2 ** 32 ? m = re(String(i)) : typeof i == "bigint" && (m = String(i), (i > BigInt(2) ** BigInt(32) || i < -(BigInt(2) ** BigInt(32))) && (m = re(m)), m += "n"), h += ` It must be ${n}. Received ${m}`, h;
    },
    RangeError
  );
  function re(c) {
    let n = "", i = c.length;
    const h = c[0] === "-" ? 1 : 0;
    for (; i >= h + 4; i -= 3)
      n = `_${c.slice(i - 3, i)}${n}`;
    return `${c.slice(0, i)}${n}`;
  }
  function he(c, n, i) {
    me(n, "offset"), (c[n] === void 0 || c[n + i] === void 0) && be(n, c.length - (i + 1));
  }
  function we(c, n, i, h, m, a) {
    if (c > i || c < n) {
      const d = typeof n == "bigint" ? "n" : "";
      let w;
      throw a > 3 ? n === 0 || n === BigInt(0) ? w = `>= 0${d} and < 2${d} ** ${(a + 1) * 8}${d}` : w = `>= -(2${d} ** ${(a + 1) * 8 - 1}${d}) and < 2 ** ${(a + 1) * 8 - 1}${d}` : w = `>= ${n}${d} and <= ${i}${d}`, new ce.ERR_OUT_OF_RANGE("value", w, c);
    }
    he(h, m, a);
  }
  function me(c, n) {
    if (typeof c != "number")
      throw new ce.ERR_INVALID_ARG_TYPE(n, "number", c);
  }
  function be(c, n, i) {
    throw Math.floor(c) !== c ? (me(c, i), new ce.ERR_OUT_OF_RANGE(i || "offset", "an integer", c)) : n < 0 ? new ce.ERR_BUFFER_OUT_OF_BOUNDS() : new ce.ERR_OUT_OF_RANGE(
      i || "offset",
      `>= ${i ? 1 : 0} and <= ${n}`,
      c
    );
  }
  const Oe = /[^+/0-9A-Za-z-_]/g;
  function mt(c) {
    if (c = c.split("=")[0], c = c.trim().replace(Oe, ""), c.length < 2)
      return "";
    for (; c.length % 4 !== 0; )
      c = c + "=";
    return c;
  }
  function et(c, n) {
    n = n || 1 / 0;
    let i;
    const h = c.length;
    let m = null;
    const a = [];
    for (let d = 0; d < h; ++d) {
      if (i = c.charCodeAt(d), i > 55295 && i < 57344) {
        if (!m) {
          if (i > 56319) {
            (n -= 3) > -1 && a.push(239, 191, 189);
            continue;
          } else if (d + 1 === h) {
            (n -= 3) > -1 && a.push(239, 191, 189);
            continue;
          }
          m = i;
          continue;
        }
        if (i < 56320) {
          (n -= 3) > -1 && a.push(239, 191, 189), m = i;
          continue;
        }
        i = (m - 55296 << 10 | i - 56320) + 65536;
      } else
        m && (n -= 3) > -1 && a.push(239, 191, 189);
      if (m = null, i < 128) {
        if ((n -= 1) < 0)
          break;
        a.push(i);
      } else if (i < 2048) {
        if ((n -= 2) < 0)
          break;
        a.push(
          i >> 6 | 192,
          i & 63 | 128
        );
      } else if (i < 65536) {
        if ((n -= 3) < 0)
          break;
        a.push(
          i >> 12 | 224,
          i >> 6 & 63 | 128,
          i & 63 | 128
        );
      } else if (i < 1114112) {
        if ((n -= 4) < 0)
          break;
        a.push(
          i >> 18 | 240,
          i >> 12 & 63 | 128,
          i >> 6 & 63 | 128,
          i & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return a;
  }
  function Yt(c) {
    const n = [];
    for (let i = 0; i < c.length; ++i)
      n.push(c.charCodeAt(i) & 255);
    return n;
  }
  function zt(c, n) {
    let i, h, m;
    const a = [];
    for (let d = 0; d < c.length && !((n -= 2) < 0); ++d)
      i = c.charCodeAt(d), h = i >> 8, m = i % 256, a.push(m), a.push(h);
    return a;
  }
  function gt(c) {
    return t.toByteArray(mt(c));
  }
  function Pe(c, n, i, h) {
    let m;
    for (m = 0; m < h && !(m + i >= n.length || m >= c.length); ++m)
      n[m + i] = c[m];
    return m;
  }
  function Le(c, n) {
    return c instanceof n || c != null && c.constructor != null && c.constructor.name != null && c.constructor.name === n.name;
  }
  function tt(c) {
    return c !== c;
  }
  const Wt = function() {
    const c = "0123456789abcdef", n = new Array(256);
    for (let i = 0; i < 16; ++i) {
      const h = i * 16;
      for (let m = 0; m < 16; ++m)
        n[h + m] = c[i] + c[m];
    }
    return n;
  }();
  function Ie(c) {
    return typeof BigInt > "u" ? yt : c;
  }
  function yt() {
    throw new Error("BigInt not supported");
  }
})(Or);
window.Buffer = window.Buffer || Or.Buffer;
function Us(e) {
  let t = 0;
  if (e.length === 0)
    return t;
  for (let r = 0; r < e.length; r++)
    t = (t << 5) - t + e.charCodeAt(r), t = t & t;
  return t;
}
const ot = {
  ////https://auth0.com/docs/api-auth/tutorials/nonce
  randomString(e) {
    const t = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._";
    let r = "";
    for (; e > 0; ) {
      const s = new Uint8Array(16);
      (window.crypto || window.msCrypto).getRandomValues(s).forEach(function(f) {
        e !== 0 && f < t.length && (r += t[f], e--);
      });
    }
    return r;
  },
  //https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
  async generateHashArray(e) {
    const t = window.crypto || window.msCrypto;
    if (!t)
      return Us(e);
    const r = new TextEncoder().encode(e), s = t.subtle.digest("SHA-256", r);
    return typeof s.then == "function" ? Array.from(new Uint8Array(await s)) : new Promise((o) => {
      s.oncomplete = () => {
        o(Array.from(new Uint8Array(s.result)));
      };
    });
  },
  async generateHashHex(e) {
    return (await this.generateHashArray(e)).join(",");
  },
  async generateChallenge(e) {
    const t = await this.generateHashArray(e);
    return Ms(t);
  },
  async verifyHash(e, t) {
    return e && t ? await this.generateHashHex(e) === t : !1;
  }
};
function on(e) {
  this.message = e;
}
on.prototype = new Error(), on.prototype.name = "InvalidCharacterError";
var zn = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1)
    throw new on("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, s, o = 0, u = 0, f = ""; s = t.charAt(u++); ~s && (r = o % 4 ? 64 * r + s : s, o++ % 4) ? f += String.fromCharCode(255 & r >> (-2 * o & 6)) : 0)
    s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s);
  return f;
};
function Hs(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(zn(r).replace(/(.)/g, function(s, o) {
        var u = o.charCodeAt(0).toString(16).toUpperCase();
        return u.length < 2 && (u = "0" + u), "%" + u;
      }));
    }(t);
  } catch {
    return zn(t);
  }
}
function It(e) {
  this.message = e;
}
function Vs(e, t) {
  if (typeof e != "string")
    throw new It("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(Hs(e.split(".")[r]));
  } catch (s) {
    throw new It("Invalid token specified: " + s.message);
  }
}
It.prototype = new Error(), It.prototype.name = "InvalidTokenError";
const Ze = {
  parseJwt(e) {
    return Vs(e);
  },
  isEncoded(e) {
    return e = e || "", e !== decodeURIComponent(e);
  },
  encodeUriComponent(e) {
    return this.isEncoded(e) ? e : encodeURIComponent(e);
  },
  decodeUriComponent(e) {
    return this.isEncoded(e) ? decodeURIComponent(e) : e;
  }
}, $s = (e) => ({
  variables: lt({
    authoriseUri: e.authoriseUri,
    tokenUri: e.tokenUri,
    logoutUri: e.logoutUri,
    apiHttpHeaders: e.apiHttpHeaders || {},
    secureApp: e.secureApp || !1,
    enablePopupAuth: e.enablePopupAuth || !1,
    pkce: e.pkce,
    clientSecret: e.clientSecret,
    afterLogin: e.afterLogin,
    devIdTokenOverride: e.devIdTokenOverride,
    forceProdMode: e.forceProdMode,
    params: Object.assign(
      {
        // you need to pass client_id, redirect_uri
        response_type: e.pkce ? "code" : encodeURIComponent("token id_token")
      },
      e.params
    )
  }),
  // state props
  data: nr({
    idToken: null,
    accessToken: null,
    tokenType: null,
    profile: null,
    loaded: !1
  }),
  // expose observable props as getters
  get loaded() {
    return this.data.loaded;
  },
  get profile() {
    return this.data.profile;
  },
  updateConfigVariables(t) {
    const r = [
      "authoriseUri",
      "tokenUri",
      "logoutUri",
      "apiHttpHeaders",
      "secureApp",
      "enablePopupAuth",
      "pkce",
      "clientSecret",
      "afterLogin",
      "devIdTokenOverride",
      "forceProdMode",
      "params"
    ], s = Object.entries(
      t
    ).reduce(
      (o, [u, f]) => r.includes(u) ? { ...o, [u]: f } : o,
      {}
    );
    s.params && (s.params.response_type = e.pkce ? "code" : encodeURIComponent("token id_token")), this.variables.value = { ...this.variables.value, ...s };
  },
  // functions
  clearToken: function() {
    this.data.idToken = null, this.data.accessToken = null, this.data.tokenType = null, this.data.loaded = !1, localStorage.removeItem("id_token"), localStorage.removeItem("access_token"), localStorage.removeItem("token_type"), localStorage.removeItem("token_expiry"), localStorage.removeItem("refresh_token"), sessionStorage.removeItem("nonce"), sessionStorage.removeItem("codeVerifier"), sessionStorage.removeItem("oauth-session-initialised");
  },
  isAuthenticated: function() {
    let t = !0;
    if (localStorage.getItem("access_token")) {
      const r = localStorage.getItem("token_expiry");
      if (r) {
        const o = new Date(parseFloat(r) * 1e3);
        t = /* @__PURE__ */ new Date() >= o;
      }
      const s = !t && sessionStorage.getItem("oauth-session-initialised") === "true" && this.data.accessToken != null;
      return s && this.setToken(
        localStorage.getItem("access_token"),
        localStorage.getItem("id_token"),
        localStorage.getItem("token_type"),
        localStorage.getItem("refresh_token")
      ), s;
    }
    return !1;
  },
  getAuth: async function() {
    if (process.env.NODE_ENV === "development" && !this.variables.value.forceProdMode) {
      const o = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1NTk1MjI2NDIsImV4cCI6NDA4NDA0NDI0MiwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSIsImdpdmVuTmFtZSI6IlRlc3QiLCJzbiI6IlVzZXIiLCJFbWFpbCI6InRlc3QudXNlckBkZXQubnN3LmVkdS5hdSIsIlJvbGUiOlsiTWFuYWdlciIsIlByb2plY3QgQWRtaW5pc3RyYXRvciJdfQ.kNoYM0Bgf9tVv5iqbeLAJ2uus8WTskcoNE7YH5siCCA", u = this.variables.value.devIdTokenOverride || "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1NTk1MjI2NDIsImV4cCI6NDA4NDA0NDI0MiwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSIsImdpdmVuTmFtZSI6IlRlc3QiLCJzbiI6IlVzZXIiLCJlbWFpbCI6InRlc3QudXNlckBkZXQubnN3LmVkdS5hdSIsInJvbGVzIjpbIlNDSE9PTC5QUklOQ0lQQUwiXX0.rRYKWPY-HfxOT6HzNqhqauKmD221wfEYeaAs2PEkTWk";
      return this.setToken(o, u, "Bearer"), !0;
    }
    const t = localStorage.getItem("access_token"), r = localStorage.getItem("id_token"), s = localStorage.getItem("refresh_token");
    if (!t || !this.isAuthenticated()) {
      this.clearToken();
      const o = ot.randomString(16);
      sessionStorage.setItem("nonce", o);
      const u = {
        nonce: await ot.generateHashArray(o),
        ...this.variables.value.params
      };
      if (this.variables.value.pkce) {
        const p = ot.randomString(128);
        sessionStorage.setItem("codeVerifier", p);
        const g = await ot.generateChallenge(p);
        Object.assign(u, {
          code_challenge: g,
          code_challenge_method: "S256"
        });
      }
      const f = Object.entries(u).reduce(
        (p, [g, b], O, M) => `${p}${g}=${Ze.encodeUriComponent(b)}${O < M.length - 1 ? "&" : ""}`,
        ""
      ), l = this.variables.value.authoriseUri + "?" + f, y = document.documentMode != null;
      if (!t || y || !this.variables.value.enablePopupAuth)
        window.location.href = l;
      else
        try {
          await this.refreshToken(l).then((p) => (this.setToken(
            p.accessToken,
            p.idToken,
            p.tokenType,
            p.refreshToken
          ), !0));
        } catch {
          window.location.href = l;
        }
    } else if (t && !this.data.accessToken)
      return this.setToken(
        t,
        r,
        localStorage.getItem("token_type"),
        s
      ), !0;
    return !1;
  },
  setToken(t, r, s, o) {
    if (t && t !== "undefined" && r && r !== "undefined") {
      const u = Ze.parseJwt(r);
      this.data.accessToken = t, this.data.tokenType = s, this.data.idToken = r, this.data.profile = u, localStorage.setItem("id_token", r), localStorage.setItem("access_token", t), localStorage.setItem("token_type", s || ""), localStorage.setItem("token_expiry", u.exp), o && localStorage.setItem("refresh_token", o), sessionStorage.setItem("oauth-session-initialised", "true"), this.data.loaded = !0, typeof this.variables.value.afterLogin == "function" && this.variables.value.afterLogin(t, r);
    } else
      this.clearToken();
  },
  refreshToken(t) {
    return new Promise((s) => {
      const o = window.innerWidth, u = window.innerHeight, f = window.outerHeight / 2 + window.screenY - u / 2, l = window.outerWidth / 2 + window.screenX - o / 2, y = window.open(
        t,
        "authPopup",
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + o + ", height=" + u + ", top=" + f + ", left=" + l
      );
      if (!y || y.closed || typeof y.closed > "u")
        throw "Authentication pop up was blocked";
      const p = window.setInterval(() => {
        try {
          const g = localStorage.getItem("id_token"), b = localStorage.getItem("access_token"), O = localStorage.getItem("token_type"), M = localStorage.getItem("refresh_token");
          if (b && (window.clearInterval(p), setTimeout(() => {
            y.close();
          }, 250), s({
            accessToken: b,
            idToken: g,
            tokenType: O,
            refreshToken: M
          })), y.closed)
            throw "Could not authenticate.";
        } catch {
          console.info("Waiting for authorisation token...");
        }
      }, 250);
    });
  },
  buildHttpHeader(t) {
    return { ...this.data.tokenType && this.data.accessToken && this.data.idToken ? {
      ...this.variables.value.apiHttpHeaders,
      Authorization: this.data.tokenType + " " + this.data.accessToken,
      "id-token": this.data.idToken,
      "X-Correlation-ID": +/* @__PURE__ */ new Date()
    } : {}, ...t || {} };
  },
  logout() {
    this.clearToken(), this.variables.value.logoutUri && (window.location.href = this.variables.value.logoutUri);
  }
});
function Dr(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: js } = Object.prototype, { getPrototypeOf: bn } = Object, Ut = ((e) => (t) => {
  const r = js.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ke = (e) => (e = e.toLowerCase(), (t) => Ut(t) === e), Ht = (e) => (t) => typeof t === e, { isArray: Qe } = Array, ct = Ht("undefined");
function Ys(e) {
  return e !== null && !ct(e) && e.constructor !== null && !ct(e.constructor) && Ce(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Rr = ke("ArrayBuffer");
function zs(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Rr(e.buffer), t;
}
const Ws = Ht("string"), Ce = Ht("function"), Pr = Ht("number"), Vt = (e) => e !== null && typeof e == "object", Js = (e) => e === !0 || e === !1, Lt = (e) => {
  if (Ut(e) !== "object")
    return !1;
  const t = bn(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Zs = ke("Date"), Gs = ke("File"), qs = ke("Blob"), Xs = ke("FileList"), Ks = (e) => Vt(e) && Ce(e.pipe), Qs = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ce(e.append) && ((t = Ut(e)) === "formdata" || // detect form-data instance
  t === "object" && Ce(e.toString) && e.toString() === "[object FormData]"));
}, ea = ke("URLSearchParams"), ta = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ht(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let s, o;
  if (typeof e != "object" && (e = [e]), Qe(e))
    for (s = 0, o = e.length; s < o; s++)
      t.call(null, e[s], s, e);
  else {
    const u = r ? Object.getOwnPropertyNames(e) : Object.keys(e), f = u.length;
    let l;
    for (s = 0; s < f; s++)
      l = u[s], t.call(null, e[l], l, e);
  }
}
function Nr(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let s = r.length, o;
  for (; s-- > 0; )
    if (o = r[s], t === o.toLowerCase())
      return o;
  return null;
}
const Ur = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Hr = (e) => !ct(e) && e !== Ur;
function sn() {
  const { caseless: e } = Hr(this) && this || {}, t = {}, r = (s, o) => {
    const u = e && Nr(t, o) || o;
    Lt(t[u]) && Lt(s) ? t[u] = sn(t[u], s) : Lt(s) ? t[u] = sn({}, s) : Qe(s) ? t[u] = s.slice() : t[u] = s;
  };
  for (let s = 0, o = arguments.length; s < o; s++)
    arguments[s] && ht(arguments[s], r);
  return t;
}
const na = (e, t, r, { allOwnKeys: s } = {}) => (ht(t, (o, u) => {
  r && Ce(o) ? e[u] = Dr(o, r) : e[u] = o;
}, { allOwnKeys: s }), e), ra = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), ia = (e, t, r, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, oa = (e, t, r, s) => {
  let o, u, f;
  const l = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), u = o.length; u-- > 0; )
      f = o[u], (!s || s(f, e, t)) && !l[f] && (t[f] = e[f], l[f] = !0);
    e = r !== !1 && bn(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, sa = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const s = e.indexOf(t, r);
  return s !== -1 && s === r;
}, aa = (e) => {
  if (!e)
    return null;
  if (Qe(e))
    return e;
  let t = e.length;
  if (!Pr(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, ua = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && bn(Uint8Array)), ca = (e, t) => {
  const s = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = s.next()) && !o.done; ) {
    const u = o.value;
    t.call(e, u[0], u[1]);
  }
}, la = (e, t) => {
  let r;
  const s = [];
  for (; (r = e.exec(t)) !== null; )
    s.push(r);
  return s;
}, fa = ke("HTMLFormElement"), da = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, s, o) {
    return s.toUpperCase() + o;
  }
), Wn = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), ha = ke("RegExp"), Vr = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), s = {};
  ht(r, (o, u) => {
    let f;
    (f = t(o, u, e)) !== !1 && (s[u] = f || o);
  }), Object.defineProperties(e, s);
}, pa = (e) => {
  Vr(e, (t, r) => {
    if (Ce(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const s = e[r];
    if (Ce(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, ma = (e, t) => {
  const r = {}, s = (o) => {
    o.forEach((u) => {
      r[u] = !0;
    });
  };
  return Qe(e) ? s(e) : s(String(e).split(t)), r;
}, ga = () => {
}, ya = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Xt = "abcdefghijklmnopqrstuvwxyz", Jn = "0123456789", $r = {
  DIGIT: Jn,
  ALPHA: Xt,
  ALPHA_DIGIT: Xt + Xt.toUpperCase() + Jn
}, wa = (e = 16, t = $r.ALPHA_DIGIT) => {
  let r = "";
  const { length: s } = t;
  for (; e--; )
    r += t[Math.random() * s | 0];
  return r;
};
function va(e) {
  return !!(e && Ce(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const ba = (e) => {
  const t = new Array(10), r = (s, o) => {
    if (Vt(s)) {
      if (t.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        t[o] = s;
        const u = Qe(s) ? [] : {};
        return ht(s, (f, l) => {
          const y = r(f, o + 1);
          !ct(y) && (u[l] = y);
        }), t[o] = void 0, u;
      }
    }
    return s;
  };
  return r(e, 0);
}, La = ke("AsyncFunction"), Ea = (e) => e && (Vt(e) || Ce(e)) && Ce(e.then) && Ce(e.catch), L = {
  isArray: Qe,
  isArrayBuffer: Rr,
  isBuffer: Ys,
  isFormData: Qs,
  isArrayBufferView: zs,
  isString: Ws,
  isNumber: Pr,
  isBoolean: Js,
  isObject: Vt,
  isPlainObject: Lt,
  isUndefined: ct,
  isDate: Zs,
  isFile: Gs,
  isBlob: qs,
  isRegExp: ha,
  isFunction: Ce,
  isStream: Ks,
  isURLSearchParams: ea,
  isTypedArray: ua,
  isFileList: Xs,
  forEach: ht,
  merge: sn,
  extend: na,
  trim: ta,
  stripBOM: ra,
  inherits: ia,
  toFlatObject: oa,
  kindOf: Ut,
  kindOfTest: ke,
  endsWith: sa,
  toArray: aa,
  forEachEntry: ca,
  matchAll: la,
  isHTMLForm: fa,
  hasOwnProperty: Wn,
  hasOwnProp: Wn,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Vr,
  freezeMethods: pa,
  toObjectSet: ma,
  toCamelCase: da,
  noop: ga,
  toFiniteNumber: ya,
  findKey: Nr,
  global: Ur,
  isContextDefined: Hr,
  ALPHABET: $r,
  generateString: wa,
  isSpecCompliantForm: va,
  toJSONObject: ba,
  isAsyncFn: La,
  isThenable: Ea
};
function J(e, t, r, s, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), s && (this.request = s), o && (this.response = o);
}
L.inherits(J, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: L.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const jr = J.prototype, Yr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Yr[e] = { value: e };
});
Object.defineProperties(J, Yr);
Object.defineProperty(jr, "isAxiosError", { value: !0 });
J.from = (e, t, r, s, o, u) => {
  const f = Object.create(jr);
  return L.toFlatObject(e, f, function(y) {
    return y !== Error.prototype;
  }, (l) => l !== "isAxiosError"), J.call(f, e.message, t, r, s, o), f.cause = e, f.name = e.name, u && Object.assign(f, u), f;
};
const Sa = null;
function an(e) {
  return L.isPlainObject(e) || L.isArray(e);
}
function zr(e) {
  return L.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Zn(e, t, r) {
  return e ? e.concat(t).map(function(o, u) {
    return o = zr(o), !r && u ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function Ca(e) {
  return L.isArray(e) && !e.some(an);
}
const Aa = L.toFlatObject(L, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function $t(e, t, r) {
  if (!L.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = L.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(S, P) {
    return !L.isUndefined(P[S]);
  });
  const s = r.metaTokens, o = r.visitor || g, u = r.dots, f = r.indexes, y = (r.Blob || typeof Blob < "u" && Blob) && L.isSpecCompliantForm(t);
  if (!L.isFunction(o))
    throw new TypeError("visitor must be a function");
  function p(I) {
    if (I === null)
      return "";
    if (L.isDate(I))
      return I.toISOString();
    if (!y && L.isBlob(I))
      throw new J("Blob is not supported. Use a Buffer instead.");
    return L.isArrayBuffer(I) || L.isTypedArray(I) ? y && typeof Blob == "function" ? new Blob([I]) : Buffer.from(I) : I;
  }
  function g(I, S, P) {
    let N = I;
    if (I && !P && typeof I == "object") {
      if (L.endsWith(S, "{}"))
        S = s ? S : S.slice(0, -2), I = JSON.stringify(I);
      else if (L.isArray(I) && Ca(I) || (L.isFileList(I) || L.endsWith(S, "[]")) && (N = L.toArray(I)))
        return S = zr(S), N.forEach(function(G, Y) {
          !(L.isUndefined(G) || G === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            f === !0 ? Zn([S], Y, u) : f === null ? S : S + "[]",
            p(G)
          );
        }), !1;
    }
    return an(I) ? !0 : (t.append(Zn(P, S, u), p(I)), !1);
  }
  const b = [], O = Object.assign(Aa, {
    defaultVisitor: g,
    convertValue: p,
    isVisitable: an
  });
  function M(I, S) {
    if (!L.isUndefined(I)) {
      if (b.indexOf(I) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      b.push(I), L.forEach(I, function(N, $) {
        (!(L.isUndefined(N) || N === null) && o.call(
          t,
          N,
          L.isString($) ? $.trim() : $,
          S,
          O
        )) === !0 && M(N, S ? S.concat($) : [$]);
      }), b.pop();
    }
  }
  if (!L.isObject(e))
    throw new TypeError("data must be an object");
  return M(e), t;
}
function Gn(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(s) {
    return t[s];
  });
}
function Ln(e, t) {
  this._pairs = [], e && $t(e, this, t);
}
const Wr = Ln.prototype;
Wr.append = function(t, r) {
  this._pairs.push([t, r]);
};
Wr.toString = function(t) {
  const r = t ? function(s) {
    return t.call(this, s, Gn);
  } : Gn;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function _a(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Jr(e, t, r) {
  if (!t)
    return e;
  const s = r && r.encode || _a, o = r && r.serialize;
  let u;
  if (o ? u = o(t, r) : u = L.isURLSearchParams(t) ? t.toString() : new Ln(t, r).toString(s), u) {
    const f = e.indexOf("#");
    f !== -1 && (e = e.slice(0, f)), e += (e.indexOf("?") === -1 ? "?" : "&") + u;
  }
  return e;
}
class xa {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    L.forEach(this.handlers, function(s) {
      s !== null && t(s);
    });
  }
}
const qn = xa, Zr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ia = typeof URLSearchParams < "u" ? URLSearchParams : Ln, Ba = typeof FormData < "u" ? FormData : null, Ma = typeof Blob < "u" ? Blob : null, ka = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Ta = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), xe = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ia,
    FormData: Ba,
    Blob: Ma
  },
  isStandardBrowserEnv: ka,
  isStandardBrowserWebWorkerEnv: Ta,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function Oa(e, t) {
  return $t(e, new xe.classes.URLSearchParams(), Object.assign({
    visitor: function(r, s, o, u) {
      return xe.isNode && L.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : u.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Fa(e) {
  return L.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Da(e) {
  const t = {}, r = Object.keys(e);
  let s;
  const o = r.length;
  let u;
  for (s = 0; s < o; s++)
    u = r[s], t[u] = e[u];
  return t;
}
function Gr(e) {
  function t(r, s, o, u) {
    let f = r[u++];
    const l = Number.isFinite(+f), y = u >= r.length;
    return f = !f && L.isArray(o) ? o.length : f, y ? (L.hasOwnProp(o, f) ? o[f] = [o[f], s] : o[f] = s, !l) : ((!o[f] || !L.isObject(o[f])) && (o[f] = []), t(r, s, o[f], u) && L.isArray(o[f]) && (o[f] = Da(o[f])), !l);
  }
  if (L.isFormData(e) && L.isFunction(e.entries)) {
    const r = {};
    return L.forEachEntry(e, (s, o) => {
      t(Fa(s), o, r, 0);
    }), r;
  }
  return null;
}
function Ra(e, t, r) {
  if (L.isString(e))
    try {
      return (t || JSON.parse)(e), L.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (r || JSON.stringify)(e);
}
const En = {
  transitional: Zr,
  adapter: xe.isNode ? "http" : "xhr",
  transformRequest: [function(t, r) {
    const s = r.getContentType() || "", o = s.indexOf("application/json") > -1, u = L.isObject(t);
    if (u && L.isHTMLForm(t) && (t = new FormData(t)), L.isFormData(t))
      return o && o ? JSON.stringify(Gr(t)) : t;
    if (L.isArrayBuffer(t) || L.isBuffer(t) || L.isStream(t) || L.isFile(t) || L.isBlob(t))
      return t;
    if (L.isArrayBufferView(t))
      return t.buffer;
    if (L.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (u) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return Oa(t, this.formSerializer).toString();
      if ((l = L.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
        const y = this.env && this.env.FormData;
        return $t(
          l ? { "files[]": t } : t,
          y && new y(),
          this.formSerializer
        );
      }
    }
    return u || o ? (r.setContentType("application/json", !1), Ra(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || En.transitional, s = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (t && L.isString(t) && (s && !this.responseType || o)) {
      const f = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (l) {
        if (f)
          throw l.name === "SyntaxError" ? J.from(l, J.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: xe.classes.FormData,
    Blob: xe.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
L.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  En.headers[e] = {};
});
const Sn = En, Pa = L.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Na = (e) => {
  const t = {};
  let r, s, o;
  return e && e.split(`
`).forEach(function(f) {
    o = f.indexOf(":"), r = f.substring(0, o).trim().toLowerCase(), s = f.substring(o + 1).trim(), !(!r || t[r] && Pa[r]) && (r === "set-cookie" ? t[r] ? t[r].push(s) : t[r] = [s] : t[r] = t[r] ? t[r] + ", " + s : s);
  }), t;
}, Xn = Symbol("internals");
function rt(e) {
  return e && String(e).trim().toLowerCase();
}
function Et(e) {
  return e === !1 || e == null ? e : L.isArray(e) ? e.map(Et) : String(e);
}
function Ua(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = r.exec(e); )
    t[s[1]] = s[2];
  return t;
}
const Ha = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Kt(e, t, r, s, o) {
  if (L.isFunction(s))
    return s.call(this, t, r);
  if (o && (t = r), !!L.isString(t)) {
    if (L.isString(s))
      return t.indexOf(s) !== -1;
    if (L.isRegExp(s))
      return s.test(t);
  }
}
function Va(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, s) => r.toUpperCase() + s);
}
function $a(e, t) {
  const r = L.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(e, s + r, {
      value: function(o, u, f) {
        return this[s].call(this, t, o, u, f);
      },
      configurable: !0
    });
  });
}
class jt {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, s) {
    const o = this;
    function u(l, y, p) {
      const g = rt(y);
      if (!g)
        throw new Error("header name must be a non-empty string");
      const b = L.findKey(o, g);
      (!b || o[b] === void 0 || p === !0 || p === void 0 && o[b] !== !1) && (o[b || y] = Et(l));
    }
    const f = (l, y) => L.forEach(l, (p, g) => u(p, g, y));
    return L.isPlainObject(t) || t instanceof this.constructor ? f(t, r) : L.isString(t) && (t = t.trim()) && !Ha(t) ? f(Na(t), r) : t != null && u(r, t, s), this;
  }
  get(t, r) {
    if (t = rt(t), t) {
      const s = L.findKey(this, t);
      if (s) {
        const o = this[s];
        if (!r)
          return o;
        if (r === !0)
          return Ua(o);
        if (L.isFunction(r))
          return r.call(this, o, s);
        if (L.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = rt(t), t) {
      const s = L.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!r || Kt(this, this[s], s, r)));
    }
    return !1;
  }
  delete(t, r) {
    const s = this;
    let o = !1;
    function u(f) {
      if (f = rt(f), f) {
        const l = L.findKey(s, f);
        l && (!r || Kt(s, s[l], l, r)) && (delete s[l], o = !0);
      }
    }
    return L.isArray(t) ? t.forEach(u) : u(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let s = r.length, o = !1;
    for (; s--; ) {
      const u = r[s];
      (!t || Kt(this, this[u], u, t, !0)) && (delete this[u], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, s = {};
    return L.forEach(this, (o, u) => {
      const f = L.findKey(s, u);
      if (f) {
        r[f] = Et(o), delete r[u];
        return;
      }
      const l = t ? Va(u) : String(u).trim();
      l !== u && delete r[u], r[l] = Et(o), s[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return L.forEach(this, (s, o) => {
      s != null && s !== !1 && (r[o] = t && L.isArray(s) ? s.join(", ") : s);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const s = new this(t);
    return r.forEach((o) => s.set(o)), s;
  }
  static accessor(t) {
    const s = (this[Xn] = this[Xn] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function u(f) {
      const l = rt(f);
      s[l] || ($a(o, f), s[l] = !0);
    }
    return L.isArray(t) ? t.forEach(u) : u(t), this;
  }
}
jt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
L.reduceDescriptors(jt.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[r] = s;
    }
  };
});
L.freezeMethods(jt);
const Te = jt;
function Qt(e, t) {
  const r = this || Sn, s = t || r, o = Te.from(s.headers);
  let u = s.data;
  return L.forEach(e, function(l) {
    u = l.call(r, u, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), u;
}
function qr(e) {
  return !!(e && e.__CANCEL__);
}
function pt(e, t, r) {
  J.call(this, e ?? "canceled", J.ERR_CANCELED, t, r), this.name = "CanceledError";
}
L.inherits(pt, J, {
  __CANCEL__: !0
});
function ja(e, t, r) {
  const s = r.config.validateStatus;
  !r.status || !s || s(r.status) ? e(r) : t(new J(
    "Request failed with status code " + r.status,
    [J.ERR_BAD_REQUEST, J.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const Ya = xe.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(r, s, o, u, f, l) {
        const y = [];
        y.push(r + "=" + encodeURIComponent(s)), L.isNumber(o) && y.push("expires=" + new Date(o).toGMTString()), L.isString(u) && y.push("path=" + u), L.isString(f) && y.push("domain=" + f), l === !0 && y.push("secure"), document.cookie = y.join("; ");
      },
      read: function(r) {
        const s = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
        return s ? decodeURIComponent(s[3]) : null;
      },
      remove: function(r) {
        this.write(r, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function za(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Wa(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Xr(e, t) {
  return e && !za(t) ? Wa(e, t) : t;
}
const Ja = xe.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let s;
    function o(u) {
      let f = u;
      return t && (r.setAttribute("href", f), f = r.href), r.setAttribute("href", f), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return s = o(window.location.href), function(f) {
      const l = L.isString(f) ? o(f) : f;
      return l.protocol === s.protocol && l.host === s.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function Za(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Ga(e, t) {
  e = e || 10;
  const r = new Array(e), s = new Array(e);
  let o = 0, u = 0, f;
  return t = t !== void 0 ? t : 1e3, function(y) {
    const p = Date.now(), g = s[u];
    f || (f = p), r[o] = y, s[o] = p;
    let b = u, O = 0;
    for (; b !== o; )
      O += r[b++], b = b % e;
    if (o = (o + 1) % e, o === u && (u = (u + 1) % e), p - f < t)
      return;
    const M = g && p - g;
    return M ? Math.round(O * 1e3 / M) : void 0;
  };
}
function Kn(e, t) {
  let r = 0;
  const s = Ga(50, 250);
  return (o) => {
    const u = o.loaded, f = o.lengthComputable ? o.total : void 0, l = u - r, y = s(l), p = u <= f;
    r = u;
    const g = {
      loaded: u,
      total: f,
      progress: f ? u / f : void 0,
      bytes: l,
      rate: y || void 0,
      estimated: y && f && p ? (f - u) / y : void 0,
      event: o
    };
    g[t ? "download" : "upload"] = !0, e(g);
  };
}
const qa = typeof XMLHttpRequest < "u", Xa = qa && function(e) {
  return new Promise(function(r, s) {
    let o = e.data;
    const u = Te.from(e.headers).normalize(), f = e.responseType;
    let l;
    function y() {
      e.cancelToken && e.cancelToken.unsubscribe(l), e.signal && e.signal.removeEventListener("abort", l);
    }
    L.isFormData(o) && (xe.isStandardBrowserEnv || xe.isStandardBrowserWebWorkerEnv ? u.setContentType(!1) : u.setContentType("multipart/form-data;", !1));
    let p = new XMLHttpRequest();
    if (e.auth) {
      const M = e.auth.username || "", I = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      u.set("Authorization", "Basic " + btoa(M + ":" + I));
    }
    const g = Xr(e.baseURL, e.url);
    p.open(e.method.toUpperCase(), Jr(g, e.params, e.paramsSerializer), !0), p.timeout = e.timeout;
    function b() {
      if (!p)
        return;
      const M = Te.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), S = {
        data: !f || f === "text" || f === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: M,
        config: e,
        request: p
      };
      ja(function(N) {
        r(N), y();
      }, function(N) {
        s(N), y();
      }, S), p = null;
    }
    if ("onloadend" in p ? p.onloadend = b : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, p.onabort = function() {
      p && (s(new J("Request aborted", J.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function() {
      s(new J("Network Error", J.ERR_NETWORK, e, p)), p = null;
    }, p.ontimeout = function() {
      let I = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const S = e.transitional || Zr;
      e.timeoutErrorMessage && (I = e.timeoutErrorMessage), s(new J(
        I,
        S.clarifyTimeoutError ? J.ETIMEDOUT : J.ECONNABORTED,
        e,
        p
      )), p = null;
    }, xe.isStandardBrowserEnv) {
      const M = (e.withCredentials || Ja(g)) && e.xsrfCookieName && Ya.read(e.xsrfCookieName);
      M && u.set(e.xsrfHeaderName, M);
    }
    o === void 0 && u.setContentType(null), "setRequestHeader" in p && L.forEach(u.toJSON(), function(I, S) {
      p.setRequestHeader(S, I);
    }), L.isUndefined(e.withCredentials) || (p.withCredentials = !!e.withCredentials), f && f !== "json" && (p.responseType = e.responseType), typeof e.onDownloadProgress == "function" && p.addEventListener("progress", Kn(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", Kn(e.onUploadProgress)), (e.cancelToken || e.signal) && (l = (M) => {
      p && (s(!M || M.type ? new pt(null, e, p) : M), p.abort(), p = null);
    }, e.cancelToken && e.cancelToken.subscribe(l), e.signal && (e.signal.aborted ? l() : e.signal.addEventListener("abort", l)));
    const O = Za(g);
    if (O && xe.protocols.indexOf(O) === -1) {
      s(new J("Unsupported protocol " + O + ":", J.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(o || null);
  });
}, St = {
  http: Sa,
  xhr: Xa
};
L.forEach(St, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Kr = {
  getAdapter: (e) => {
    e = L.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, s;
    for (let o = 0; o < t && (r = e[o], !(s = L.isString(r) ? St[r.toLowerCase()] : r)); o++)
      ;
    if (!s)
      throw s === !1 ? new J(
        `Adapter ${r} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        L.hasOwnProp(St, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`
      );
    if (!L.isFunction(s))
      throw new TypeError("adapter is not a function");
    return s;
  },
  adapters: St
};
function en(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new pt(null, e);
}
function Qn(e) {
  return en(e), e.headers = Te.from(e.headers), e.data = Qt.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Kr.getAdapter(e.adapter || Sn.adapter)(e).then(function(s) {
    return en(e), s.data = Qt.call(
      e,
      e.transformResponse,
      s
    ), s.headers = Te.from(s.headers), s;
  }, function(s) {
    return qr(s) || (en(e), s && s.response && (s.response.data = Qt.call(
      e,
      e.transformResponse,
      s.response
    ), s.response.headers = Te.from(s.response.headers))), Promise.reject(s);
  });
}
const er = (e) => e instanceof Te ? e.toJSON() : e;
function Ge(e, t) {
  t = t || {};
  const r = {};
  function s(p, g, b) {
    return L.isPlainObject(p) && L.isPlainObject(g) ? L.merge.call({ caseless: b }, p, g) : L.isPlainObject(g) ? L.merge({}, g) : L.isArray(g) ? g.slice() : g;
  }
  function o(p, g, b) {
    if (L.isUndefined(g)) {
      if (!L.isUndefined(p))
        return s(void 0, p, b);
    } else
      return s(p, g, b);
  }
  function u(p, g) {
    if (!L.isUndefined(g))
      return s(void 0, g);
  }
  function f(p, g) {
    if (L.isUndefined(g)) {
      if (!L.isUndefined(p))
        return s(void 0, p);
    } else
      return s(void 0, g);
  }
  function l(p, g, b) {
    if (b in t)
      return s(p, g);
    if (b in e)
      return s(void 0, p);
  }
  const y = {
    url: u,
    method: u,
    data: u,
    baseURL: f,
    transformRequest: f,
    transformResponse: f,
    paramsSerializer: f,
    timeout: f,
    timeoutMessage: f,
    withCredentials: f,
    adapter: f,
    responseType: f,
    xsrfCookieName: f,
    xsrfHeaderName: f,
    onUploadProgress: f,
    onDownloadProgress: f,
    decompress: f,
    maxContentLength: f,
    maxBodyLength: f,
    beforeRedirect: f,
    transport: f,
    httpAgent: f,
    httpsAgent: f,
    cancelToken: f,
    socketPath: f,
    responseEncoding: f,
    validateStatus: l,
    headers: (p, g) => o(er(p), er(g), !0)
  };
  return L.forEach(Object.keys(Object.assign({}, e, t)), function(g) {
    const b = y[g] || o, O = b(e[g], t[g], g);
    L.isUndefined(O) && b !== l || (r[g] = O);
  }), r;
}
const Qr = "1.5.0", Cn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Cn[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const tr = {};
Cn.transitional = function(t, r, s) {
  function o(u, f) {
    return "[Axios v" + Qr + "] Transitional option '" + u + "'" + f + (s ? ". " + s : "");
  }
  return (u, f, l) => {
    if (t === !1)
      throw new J(
        o(f, " has been removed" + (r ? " in " + r : "")),
        J.ERR_DEPRECATED
      );
    return r && !tr[f] && (tr[f] = !0, console.warn(
      o(
        f,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(u, f, l) : !0;
  };
};
function Ka(e, t, r) {
  if (typeof e != "object")
    throw new J("options must be an object", J.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let o = s.length;
  for (; o-- > 0; ) {
    const u = s[o], f = t[u];
    if (f) {
      const l = e[u], y = l === void 0 || f(l, u, e);
      if (y !== !0)
        throw new J("option " + u + " must be " + y, J.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new J("Unknown option " + u, J.ERR_BAD_OPTION);
  }
}
const un = {
  assertOptions: Ka,
  validators: Cn
}, Fe = un.validators;
class Bt {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new qn(),
      response: new qn()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Ge(this.defaults, r);
    const { transitional: s, paramsSerializer: o, headers: u } = r;
    s !== void 0 && un.assertOptions(s, {
      silentJSONParsing: Fe.transitional(Fe.boolean),
      forcedJSONParsing: Fe.transitional(Fe.boolean),
      clarifyTimeoutError: Fe.transitional(Fe.boolean)
    }, !1), o != null && (L.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : un.assertOptions(o, {
      encode: Fe.function,
      serialize: Fe.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let f = u && L.merge(
      u.common,
      u[r.method]
    );
    u && L.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (I) => {
        delete u[I];
      }
    ), r.headers = Te.concat(f, u);
    const l = [];
    let y = !0;
    this.interceptors.request.forEach(function(S) {
      typeof S.runWhen == "function" && S.runWhen(r) === !1 || (y = y && S.synchronous, l.unshift(S.fulfilled, S.rejected));
    });
    const p = [];
    this.interceptors.response.forEach(function(S) {
      p.push(S.fulfilled, S.rejected);
    });
    let g, b = 0, O;
    if (!y) {
      const I = [Qn.bind(this), void 0];
      for (I.unshift.apply(I, l), I.push.apply(I, p), O = I.length, g = Promise.resolve(r); b < O; )
        g = g.then(I[b++], I[b++]);
      return g;
    }
    O = l.length;
    let M = r;
    for (b = 0; b < O; ) {
      const I = l[b++], S = l[b++];
      try {
        M = I(M);
      } catch (P) {
        S.call(this, P);
        break;
      }
    }
    try {
      g = Qn.call(this, M);
    } catch (I) {
      return Promise.reject(I);
    }
    for (b = 0, O = p.length; b < O; )
      g = g.then(p[b++], p[b++]);
    return g;
  }
  getUri(t) {
    t = Ge(this.defaults, t);
    const r = Xr(t.baseURL, t.url);
    return Jr(r, t.params, t.paramsSerializer);
  }
}
L.forEach(["delete", "get", "head", "options"], function(t) {
  Bt.prototype[t] = function(r, s) {
    return this.request(Ge(s || {}, {
      method: t,
      url: r,
      data: (s || {}).data
    }));
  };
});
L.forEach(["post", "put", "patch"], function(t) {
  function r(s) {
    return function(u, f, l) {
      return this.request(Ge(l || {}, {
        method: t,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: u,
        data: f
      }));
    };
  }
  Bt.prototype[t] = r(), Bt.prototype[t + "Form"] = r(!0);
});
const Ct = Bt;
class An {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(u) {
      r = u;
    });
    const s = this;
    this.promise.then((o) => {
      if (!s._listeners)
        return;
      let u = s._listeners.length;
      for (; u-- > 0; )
        s._listeners[u](o);
      s._listeners = null;
    }), this.promise.then = (o) => {
      let u;
      const f = new Promise((l) => {
        s.subscribe(l), u = l;
      }).then(o);
      return f.cancel = function() {
        s.unsubscribe(u);
      }, f;
    }, t(function(u, f, l) {
      s.reason || (s.reason = new pt(u, f, l), r(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new An(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const Qa = An;
function eu(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function tu(e) {
  return L.isObject(e) && e.isAxiosError === !0;
}
const cn = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(cn).forEach(([e, t]) => {
  cn[t] = e;
});
const nu = cn;
function ei(e) {
  const t = new Ct(e), r = Dr(Ct.prototype.request, t);
  return L.extend(r, Ct.prototype, t, { allOwnKeys: !0 }), L.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return ei(Ge(e, o));
  }, r;
}
const fe = ei(Sn);
fe.Axios = Ct;
fe.CanceledError = pt;
fe.CancelToken = Qa;
fe.isCancel = qr;
fe.VERSION = Qr;
fe.toFormData = $t;
fe.AxiosError = J;
fe.Cancel = fe.CanceledError;
fe.all = function(t) {
  return Promise.all(t);
};
fe.spread = eu;
fe.isAxiosError = tu;
fe.mergeConfig = Ge;
fe.AxiosHeaders = Te;
fe.formToJSON = (e) => Gr(L.isHTMLForm(e) ? new FormData(e) : e);
fe.getAdapter = Kr.getAdapter;
fe.HttpStatusCode = nu;
fe.default = fe;
const ru = fe;
function iu(e) {
  const t = e.split("&"), r = {};
  let s, o;
  for (s = 0; s < t.length; s++)
    o = t[s].split("="), o.length < 2 && o.push(""), r[decodeURIComponent(o[0])] = decodeURIComponent(o[1]);
  return r;
}
async function ou(e, t, r, s, o, u) {
  const f = {
    code: e,
    grant_type: "authorization_code",
    client_id: s,
    client_secret: u || "",
    code_verifier: t,
    redirect_uri: o
  }, l = [];
  for (const b in f)
    l.push(
      Ze.encodeUriComponent(b) + "=" + Ze.encodeUriComponent(f[b] || "")
    );
  const y = l.join("&");
  return (await ru({
    url: r,
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json"
    },
    data: y
  })).data;
}
const su = {
  attachOAuthRoutes(e, t) {
    let r;
    try {
      r = new URL(t).pathname;
    } catch {
      r = "/login/callback";
    }
    const s = {
      path: r,
      name: "loginCallback",
      meta: {
        protected: !1
      },
      beforeEnter: async (o, u, f) => {
        let l, y;
        const p = sessionStorage.getItem("nonce");
        sessionStorage.removeItem("nonce");
        const g = Je("$OAuth");
        if (g?.variables.value.pkce) {
          const b = sessionStorage.getItem("codeVerifier");
          sessionStorage.removeItem("codeVerifier");
          const O = o.query, M = g.variables.value.tokenUri || `${O.iss}/access_token`;
          O.code && (l = await ou(
            O.code,
            b,
            M,
            g.variables.value.params.client_id,
            g.variables.value.params.redirect_uri,
            g.variables.value.clientSecret
          ), y = Ze.parseJwt(l.id_token));
        } else {
          const b = o.hash.replace(/^#?(.*)/, "$1");
          l = iu(b), y = Ze.parseJwt(l.id_token);
        }
        if (y && await ot.verifyHash(p, y.nonce)) {
          g?.setToken(
            l.access_token,
            l.id_token,
            l.token_type,
            l.refresh_token
          );
          const b = sessionStorage.getItem("oauth-redirect-after-callback") || "/";
          sessionStorage.removeItem("oauth-redirect-after-callback"), f(b);
        } else
          throw typeof g?.variables.value.afterLogin == "function" && g.variables.value.afterLogin(), "Authorisation not valid. Try again.";
      }
    };
    e.addRoute(s), e.beforeEach(
      async (o, u, f) => {
        const l = Je("$OAuth"), y = l?.isAuthenticated();
        if ((l?.variables.value.secureApp || o.meta && o.meta.protected) && o.name !== "loginCallback" && !y && (sessionStorage.setItem(
          "oauth-redirect-after-callback",
          o.fullPath
        ), !await l?.getAuth()))
          return f(!1);
        f();
      }
    );
  }
}, fu = {
  install: function(e, t) {
    if (!t.authoriseUri)
      throw "OAuth plugin error. You must pass 'authoriseUri' in options";
    if (!t.params.client_id)
      throw "OAuth plugin error. You must pass 'params.client_id' in options";
    if (!t.params.redirect_uri)
      throw "OAuth plugin error. You must pass 'params.redirect_uri' in options";
    t.router && su.attachOAuthRoutes(
      t.router,
      t.params.redirect_uri
    ), e.provide("$OAuth", $s(t));
  }
};
var ti = { exports: {} };
(function(e) {
  (function() {
    function t(a, d, w) {
      return a.call.apply(a.bind, arguments);
    }
    function r(a, d, w) {
      if (!a)
        throw Error();
      if (2 < arguments.length) {
        var v = Array.prototype.slice.call(arguments, 2);
        return function() {
          var E = Array.prototype.slice.call(arguments);
          return Array.prototype.unshift.apply(E, v), a.apply(d, E);
        };
      }
      return function() {
        return a.apply(d, arguments);
      };
    }
    function s(a, d, w) {
      return s = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? t : r, s.apply(null, arguments);
    }
    var o = Date.now || function() {
      return +/* @__PURE__ */ new Date();
    };
    function u(a, d) {
      this.a = a, this.o = d || a, this.c = this.o.document;
    }
    var f = !!window.FontFace;
    function l(a, d, w, v) {
      if (d = a.c.createElement(d), w)
        for (var E in w)
          w.hasOwnProperty(E) && (E == "style" ? d.style.cssText = w[E] : d.setAttribute(E, w[E]));
      return v && d.appendChild(a.c.createTextNode(v)), d;
    }
    function y(a, d, w) {
      a = a.c.getElementsByTagName(d)[0], a || (a = document.documentElement), a.insertBefore(w, a.lastChild);
    }
    function p(a) {
      a.parentNode && a.parentNode.removeChild(a);
    }
    function g(a, d, w) {
      d = d || [], w = w || [];
      for (var v = a.className.split(/\s+/), E = 0; E < d.length; E += 1) {
        for (var x = !1, B = 0; B < v.length; B += 1)
          if (d[E] === v[B]) {
            x = !0;
            break;
          }
        x || v.push(d[E]);
      }
      for (d = [], E = 0; E < v.length; E += 1) {
        for (x = !1, B = 0; B < w.length; B += 1)
          if (v[E] === w[B]) {
            x = !0;
            break;
          }
        x || d.push(v[E]);
      }
      a.className = d.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function b(a, d) {
      for (var w = a.className.split(/\s+/), v = 0, E = w.length; v < E; v++)
        if (w[v] == d)
          return !0;
      return !1;
    }
    function O(a) {
      return a.o.location.hostname || a.a.location.hostname;
    }
    function M(a, d, w) {
      function v() {
        Z && E && x && (Z(B), Z = null);
      }
      d = l(a, "link", { rel: "stylesheet", href: d, media: "all" });
      var E = !1, x = !0, B = null, Z = w || null;
      f ? (d.onload = function() {
        E = !0, v();
      }, d.onerror = function() {
        E = !0, B = Error("Stylesheet failed to load"), v();
      }) : setTimeout(function() {
        E = !0, v();
      }, 0), y(a, "head", d);
    }
    function I(a, d, w, v) {
      var E = a.c.getElementsByTagName("head")[0];
      if (E) {
        var x = l(a, "script", { src: d }), B = !1;
        return x.onload = x.onreadystatechange = function() {
          B || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (B = !0, w && w(null), x.onload = x.onreadystatechange = null, x.parentNode.tagName == "HEAD" && E.removeChild(x));
        }, E.appendChild(x), setTimeout(function() {
          B || (B = !0, w && w(Error("Script load timeout")));
        }, v || 5e3), x;
      }
      return null;
    }
    function S() {
      this.a = 0, this.c = null;
    }
    function P(a) {
      return a.a++, function() {
        a.a--, $(a);
      };
    }
    function N(a, d) {
      a.c = d, $(a);
    }
    function $(a) {
      a.a == 0 && a.c && (a.c(), a.c = null);
    }
    function G(a) {
      this.a = a || "-";
    }
    G.prototype.c = function(a) {
      for (var d = [], w = 0; w < arguments.length; w++)
        d.push(arguments[w].replace(/[\W_]+/g, "").toLowerCase());
      return d.join(this.a);
    };
    function Y(a, d) {
      this.c = a, this.f = 4, this.a = "n";
      var w = (d || "n4").match(/^([nio])([1-9])$/i);
      w && (this.a = w[1], this.f = parseInt(w[2], 10));
    }
    function te(a) {
      return ae(a) + " " + (a.f + "00") + " 300px " + ie(a.c);
    }
    function ie(a) {
      var d = [];
      a = a.split(/,\s*/);
      for (var w = 0; w < a.length; w++) {
        var v = a[w].replace(/['"]/g, "");
        v.indexOf(" ") != -1 || /^\d/.test(v) ? d.push("'" + v + "'") : d.push(v);
      }
      return d.join(",");
    }
    function q(a) {
      return a.a + a.f;
    }
    function ae(a) {
      var d = "normal";
      return a.a === "o" ? d = "oblique" : a.a === "i" && (d = "italic"), d;
    }
    function de(a) {
      var d = 4, w = "n", v = null;
      return a && ((v = a.match(/(normal|oblique|italic)/i)) && v[1] && (w = v[1].substr(0, 1).toLowerCase()), (v = a.match(/([1-9]00|normal|bold)/i)) && v[1] && (/bold/i.test(v[1]) ? d = 7 : /[1-9]00/.test(v[1]) && (d = parseInt(v[1].substr(0, 1), 10)))), w + d;
    }
    function z(a, d) {
      this.c = a, this.f = a.o.document.documentElement, this.h = d, this.a = new G("-"), this.j = d.events !== !1, this.g = d.classes !== !1;
    }
    function U(a) {
      a.g && g(a.f, [a.a.c("wf", "loading")]), W(a, "loading");
    }
    function H(a) {
      if (a.g) {
        var d = b(a.f, a.a.c("wf", "active")), w = [], v = [a.a.c("wf", "loading")];
        d || w.push(a.a.c("wf", "inactive")), g(a.f, w, v);
      }
      W(a, "inactive");
    }
    function W(a, d, w) {
      a.j && a.h[d] && (w ? a.h[d](w.c, q(w)) : a.h[d]());
    }
    function T() {
      this.c = {};
    }
    function _(a, d, w) {
      var v = [], E;
      for (E in d)
        if (d.hasOwnProperty(E)) {
          var x = a.c[E];
          x && v.push(x(d[E], w));
        }
      return v;
    }
    function C(a, d) {
      this.c = a, this.f = d, this.a = l(this.c, "span", { "aria-hidden": "true" }, this.f);
    }
    function k(a) {
      y(a.c, "body", a.a);
    }
    function A(a) {
      return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + ie(a.c) + ";" + ("font-style:" + ae(a) + ";font-weight:" + (a.f + "00") + ";");
    }
    function F(a, d, w, v, E, x) {
      this.g = a, this.j = d, this.a = v, this.c = w, this.f = E || 3e3, this.h = x || void 0;
    }
    F.prototype.start = function() {
      var a = this.c.o.document, d = this, w = o(), v = new Promise(function(B, Z) {
        function K() {
          o() - w >= d.f ? Z() : a.fonts.load(te(d.a), d.h).then(function(oe) {
            1 <= oe.length ? B() : setTimeout(K, 25);
          }, function() {
            Z();
          });
        }
        K();
      }), E = null, x = new Promise(function(B, Z) {
        E = setTimeout(Z, d.f);
      });
      Promise.race([x, v]).then(function() {
        E && (clearTimeout(E), E = null), d.g(d.a);
      }, function() {
        d.j(d.a);
      });
    };
    function R(a, d, w, v, E, x, B) {
      this.v = a, this.B = d, this.c = w, this.a = v, this.s = B || "BESbswy", this.f = {}, this.w = E || 3e3, this.u = x || null, this.m = this.j = this.h = this.g = null, this.g = new C(this.c, this.s), this.h = new C(this.c, this.s), this.j = new C(this.c, this.s), this.m = new C(this.c, this.s), a = new Y(this.a.c + ",serif", q(this.a)), a = A(a), this.g.a.style.cssText = a, a = new Y(this.a.c + ",sans-serif", q(this.a)), a = A(a), this.h.a.style.cssText = a, a = new Y("serif", q(this.a)), a = A(a), this.j.a.style.cssText = a, a = new Y("sans-serif", q(this.a)), a = A(a), this.m.a.style.cssText = a, k(this.g), k(this.h), k(this.j), k(this.m);
    }
    var D = { D: "serif", C: "sans-serif" }, V = null;
    function ee() {
      if (V === null) {
        var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
        V = !!a && (536 > parseInt(a[1], 10) || parseInt(a[1], 10) === 536 && 11 >= parseInt(a[2], 10));
      }
      return V;
    }
    R.prototype.start = function() {
      this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = o(), ue(this);
    };
    function ne(a, d, w) {
      for (var v in D)
        if (D.hasOwnProperty(v) && d === a.f[D[v]] && w === a.f[D[v]])
          return !0;
      return !1;
    }
    function ue(a) {
      var d = a.g.a.offsetWidth, w = a.h.a.offsetWidth, v;
      (v = d === a.f.serif && w === a.f["sans-serif"]) || (v = ee() && ne(a, d, w)), v ? o() - a.A >= a.w ? ee() && ne(a, d, w) && (a.u === null || a.u.hasOwnProperty(a.a.c)) ? pe(a, a.v) : pe(a, a.B) : ve(a) : pe(a, a.v);
    }
    function ve(a) {
      setTimeout(s(function() {
        ue(this);
      }, a), 50);
    }
    function pe(a, d) {
      setTimeout(s(function() {
        p(this.g.a), p(this.h.a), p(this.j.a), p(this.m.a), d(this.a);
      }, a), 0);
    }
    function ce(a, d, w) {
      this.c = a, this.a = d, this.f = 0, this.m = this.j = !1, this.s = w;
    }
    var le = null;
    ce.prototype.g = function(a) {
      var d = this.a;
      d.g && g(d.f, [d.a.c("wf", a.c, q(a).toString(), "active")], [d.a.c("wf", a.c, q(a).toString(), "loading"), d.a.c("wf", a.c, q(a).toString(), "inactive")]), W(d, "fontactive", a), this.m = !0, re(this);
    }, ce.prototype.h = function(a) {
      var d = this.a;
      if (d.g) {
        var w = b(d.f, d.a.c("wf", a.c, q(a).toString(), "active")), v = [], E = [d.a.c("wf", a.c, q(a).toString(), "loading")];
        w || v.push(d.a.c("wf", a.c, q(a).toString(), "inactive")), g(d.f, v, E);
      }
      W(d, "fontinactive", a), re(this);
    };
    function re(a) {
      --a.f == 0 && a.j && (a.m ? (a = a.a, a.g && g(a.f, [a.a.c("wf", "active")], [a.a.c("wf", "loading"), a.a.c("wf", "inactive")]), W(a, "active")) : H(a.a));
    }
    function he(a) {
      this.j = a, this.a = new T(), this.h = 0, this.f = this.g = !0;
    }
    he.prototype.load = function(a) {
      this.c = new u(this.j, a.context || this.j), this.g = a.events !== !1, this.f = a.classes !== !1, me(this, new z(this.c, a), a);
    };
    function we(a, d, w, v, E) {
      var x = --a.h == 0;
      (a.f || a.g) && setTimeout(function() {
        var B = E || null, Z = v || null || {};
        if (w.length === 0 && x)
          H(d.a);
        else {
          d.f += w.length, x && (d.j = x);
          var K, oe = [];
          for (K = 0; K < w.length; K++) {
            var se = w[K], ye = Z[se.c], Ae = d.a, He = se;
            if (Ae.g && g(Ae.f, [Ae.a.c("wf", He.c, q(He).toString(), "loading")]), W(Ae, "fontloading", He), Ae = null, le === null)
              if (window.FontFace) {
                var He = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), ni = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                le = He ? 42 < parseInt(He[1], 10) : !ni;
              } else
                le = !1;
            le ? Ae = new F(s(d.g, d), s(d.h, d), d.c, se, d.s, ye) : Ae = new R(s(d.g, d), s(d.h, d), d.c, se, d.s, B, ye), oe.push(Ae);
          }
          for (K = 0; K < oe.length; K++)
            oe[K].start();
        }
      }, 0);
    }
    function me(a, d, w) {
      var E = [], v = w.timeout;
      U(d);
      var E = _(a.a, w, a.c), x = new ce(a.c, d, v);
      for (a.h = E.length, d = 0, w = E.length; d < w; d++)
        E[d].load(function(B, Z, K) {
          we(a, x, B, Z, K);
        });
    }
    function be(a, d) {
      this.c = a, this.a = d;
    }
    be.prototype.load = function(a) {
      function d() {
        if (x["__mti_fntLst" + v]) {
          var B = x["__mti_fntLst" + v](), Z = [], K;
          if (B)
            for (var oe = 0; oe < B.length; oe++) {
              var se = B[oe].fontfamily;
              B[oe].fontStyle != null && B[oe].fontWeight != null ? (K = B[oe].fontStyle + B[oe].fontWeight, Z.push(new Y(se, K))) : Z.push(new Y(se));
            }
          a(Z);
        } else
          setTimeout(function() {
            d();
          }, 50);
      }
      var w = this, v = w.a.projectId, E = w.a.version;
      if (v) {
        var x = w.c.o;
        I(this.c, (w.a.api || "https://fast.fonts.net/jsapi") + "/" + v + ".js" + (E ? "?v=" + E : ""), function(B) {
          B ? a([]) : (x["__MonotypeConfiguration__" + v] = function() {
            return w.a;
          }, d());
        }).id = "__MonotypeAPIScript__" + v;
      } else
        a([]);
    };
    function Oe(a, d) {
      this.c = a, this.a = d;
    }
    Oe.prototype.load = function(a) {
      var d, w, v = this.a.urls || [], E = this.a.families || [], x = this.a.testStrings || {}, B = new S();
      for (d = 0, w = v.length; d < w; d++)
        M(this.c, v[d], P(B));
      var Z = [];
      for (d = 0, w = E.length; d < w; d++)
        if (v = E[d].split(":"), v[1])
          for (var K = v[1].split(","), oe = 0; oe < K.length; oe += 1)
            Z.push(new Y(v[0], K[oe]));
        else
          Z.push(new Y(v[0]));
      N(B, function() {
        a(Z, x);
      });
    };
    function mt(a, d) {
      a ? this.c = a : this.c = et, this.a = [], this.f = [], this.g = d || "";
    }
    var et = "https://fonts.googleapis.com/css";
    function Yt(a, d) {
      for (var w = d.length, v = 0; v < w; v++) {
        var E = d[v].split(":");
        E.length == 3 && a.f.push(E.pop());
        var x = "";
        E.length == 2 && E[1] != "" && (x = ":"), a.a.push(E.join(x));
      }
    }
    function zt(a) {
      if (a.a.length == 0)
        throw Error("No fonts to load!");
      if (a.c.indexOf("kit=") != -1)
        return a.c;
      for (var d = a.a.length, w = [], v = 0; v < d; v++)
        w.push(a.a[v].replace(/ /g, "+"));
      return d = a.c + "?family=" + w.join("%7C"), 0 < a.f.length && (d += "&subset=" + a.f.join(",")), 0 < a.g.length && (d += "&text=" + encodeURIComponent(a.g)), d;
    }
    function gt(a) {
      this.f = a, this.a = [], this.c = {};
    }
    var Pe = { latin: "BESbswy", "latin-ext": "çöüğş", cyrillic: "йяЖ", greek: "αβΣ", khmer: "កខគ", Hanuman: "កខគ" }, Le = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, tt = { i: "i", italic: "i", n: "n", normal: "n" }, Wt = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Ie(a) {
      for (var d = a.f.length, w = 0; w < d; w++) {
        var v = a.f[w].split(":"), E = v[0].replace(/\+/g, " "), x = ["n4"];
        if (2 <= v.length) {
          var B, Z = v[1];
          if (B = [], Z)
            for (var Z = Z.split(","), K = Z.length, oe = 0; oe < K; oe++) {
              var se;
              if (se = Z[oe], se.match(/^[\w-]+$/)) {
                var ye = Wt.exec(se.toLowerCase());
                if (ye == null)
                  se = "";
                else {
                  if (se = ye[2], se = se == null || se == "" ? "n" : tt[se], ye = ye[1], ye == null || ye == "")
                    ye = "4";
                  else
                    var Ae = Le[ye], ye = Ae || (isNaN(ye) ? "4" : ye.substr(0, 1));
                  se = [se, ye].join("");
                }
              } else
                se = "";
              se && B.push(se);
            }
          0 < B.length && (x = B), v.length == 3 && (v = v[2], B = [], v = v ? v.split(",") : B, 0 < v.length && (v = Pe[v[0]]) && (a.c[E] = v));
        }
        for (a.c[E] || (v = Pe[E]) && (a.c[E] = v), v = 0; v < x.length; v += 1)
          a.a.push(new Y(E, x[v]));
      }
    }
    function yt(a, d) {
      this.c = a, this.a = d;
    }
    var c = { Arimo: !0, Cousine: !0, Tinos: !0 };
    yt.prototype.load = function(a) {
      var d = new S(), w = this.c, v = new mt(this.a.api, this.a.text), E = this.a.families;
      Yt(v, E);
      var x = new gt(E);
      Ie(x), M(w, zt(v), P(d)), N(d, function() {
        a(x.a, x.c, c);
      });
    };
    function n(a, d) {
      this.c = a, this.a = d;
    }
    n.prototype.load = function(a) {
      var d = this.a.id, w = this.c.o;
      d ? I(this.c, (this.a.api || "https://use.typekit.net") + "/" + d + ".js", function(v) {
        if (v)
          a([]);
        else if (w.Typekit && w.Typekit.config && w.Typekit.config.fn) {
          v = w.Typekit.config.fn;
          for (var E = [], x = 0; x < v.length; x += 2)
            for (var B = v[x], Z = v[x + 1], K = 0; K < Z.length; K++)
              E.push(new Y(B, Z[K]));
          try {
            w.Typekit.load({ events: !1, classes: !1, async: !0 });
          } catch {
          }
          a(E);
        }
      }, 2e3) : a([]);
    };
    function i(a, d) {
      this.c = a, this.f = d, this.a = [];
    }
    i.prototype.load = function(a) {
      var d = this.f.id, w = this.c.o, v = this;
      d ? (w.__webfontfontdeckmodule__ || (w.__webfontfontdeckmodule__ = {}), w.__webfontfontdeckmodule__[d] = function(E, x) {
        for (var B = 0, Z = x.fonts.length; B < Z; ++B) {
          var K = x.fonts[B];
          v.a.push(new Y(K.name, de("font-weight:" + K.weight + ";font-style:" + K.style)));
        }
        a(v.a);
      }, I(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + O(this.c) + "/" + d + ".js", function(E) {
        E && a([]);
      })) : a([]);
    };
    var h = new he(window);
    h.a.c.custom = function(a, d) {
      return new Oe(d, a);
    }, h.a.c.fontdeck = function(a, d) {
      return new i(d, a);
    }, h.a.c.monotype = function(a, d) {
      return new be(d, a);
    }, h.a.c.typekit = function(a, d) {
      return new n(d, a);
    }, h.a.c.google = function(a, d) {
      return new yt(d, a);
    };
    var m = { load: s(h.load, h) };
    e.exports ? e.exports = m : (window.WebFont = m, window.WebFontConfig && h.load(window.WebFontConfig));
  })();
})(ti);
var au = ti.exports;
async function du() {
  const e = document.createElement("link");
  e.rel = "dns-prefetch", e.href = "//fonts.googleapis.com", document.head.appendChild(e);
  const t = document.createElement("link");
  t.rel = "preconnect", t.href = "https://fonts.gstatic.com", t.crossOrigin = "crossorigin", document.head.appendChild(t), await new Promise((r) => {
    au.load(
      /** Webfont Config */
      {
        google: {
          families: [
            "Public+Sans:100,300,400,500,700,900&display=swap"
            // Emoji Fix
            // (Only put `display=swap` on the last line.)
            // 'Noto+Color+Emoji&display=swap',
          ]
        },
        active: () => {
          r();
        }
      }
    );
  });
}
const hu = {
  install: (e) => {
    for (const [t, r] of Object.entries(Yo))
      e.component(t, r);
  }
};
export {
  X as ADS_COLORS,
  Yo as AdsComponents,
  jn as AdsIcons,
  fu as OAuth,
  cu as ads,
  hu as default,
  du as loadFonts
};
//# sourceMappingURL=ads-v3.es.js.map
